import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { cloneDeep, set } from 'lodash';
import { Dropdown, Typography, Drawer, Tree, Button, Spin, Radio, Form, Progress, Descriptions, Modal, Popconfirm, Layout, Alert, Upload, message, Space, Input, Table, Row, Col, Badge, Tooltip } from 'antd';
import { MenuOutlined, CloudUploadOutlined, FileAddOutlined, FileZipOutlined, InboxOutlined, SearchOutlined, FolderAddFilled, EyeOutlined, FileExclamationOutlined, CloseOutlined, FileOutlined, EditOutlined, SaveOutlined, FolderOutlined, DownloadOutlined, DeleteOutlined, WarningOutlined, QuestionCircleOutlined, ReloadOutlined, BarChartOutlined, FileSyncOutlined, } from '@ant-design/icons';
import config from '../../config';
import { selectAppPermissions } from '../../store/auth/selectors';
import { checkFolderName, createFolder } from '../../services/project/checkFolder';
import { logAction } from './logActionsPOA';
import { fetchPoaDataByPath, ActualizarTipoEntrega, ValidarEstadoActa } from '../../services/poa/get_poaDocumentosMedios';
import { enviarHistorico } from '../../services/poa/check_file_service';
import { ModalSoporteReemplazo } from "../DocumentoReemplazo/ModalSoporteReemplazo";
import FileManagerModal from "../PoaEliminar/FileManagerModal";
import Informe332 from '../informe332/Informe332';
import './FileManagerPOA.css';

const { Content, Sider } = Layout;
const { Dragger } = Upload;
const { DirectoryTree } = Tree;
const baseUrl = config.baseUrl;

const truncateText = (text, maxLength) => {
    if (!text || typeof text !== 'string') {
        return '';
    }
    if (text.length <= maxLength) {
        return text;
    }
    return text.substring(0, maxLength) + '...';
};

const cleanFileName = (encodedFileName) => {
    const decodedFileName = decodeURIComponent(encodedFileName);
    const match = decodedFileName.match(/^(\d+)-(.+)$/);
    return match ? match[2] : decodedFileName;
};

const truncateTextName = (text, maxLength) => {
    if (!text || typeof text !== 'string') {
        return '';
    }
    if (text.length <= maxLength) {
        return text;
    }
    return text.substring(0, maxLength) + '...';
};

const processFileName = (fileName, maxLength) => {
    const cleanedFileName = cleanFileName(fileName);
    return truncateTextName(cleanedFileName, maxLength);
};

const FileManagerPOA = ({ codigo_tarea, onClose }) => {
    const { Title, Paragraph, Text } = Typography;
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const [showDescriptions, setShowDescriptions] = useState(true);

    const handleClose = () => {
        setIsVisible(false);
        onClose();
        setTreeData([]);
        setDataFile(null);
        setExpandedKeys([]);
    };

    // ** Estados relacionados con la estructura del árbol **
    const [treeData, setTreeData] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [expandAll] = useState(true);
    const [autoExpandParent, setAutoExpandParent] = useState(true);
    const [rootNodeSelected, setRootNodeSelected] = useState(true);

    // ** Estados de selección y edición **
    const [selectedItem, setSelectedItem] = useState(null);
    const [newName, setNewName] = useState(selectedItem ? selectedItem.name : '');
    const [isEditing, setIsEditing] = useState(false);
    const [activeButton, setActiveButton] = useState(null);
    const [newFolderName, setNewFolderName] = useState('');
    // ** Estados de búsqueda y filtros **
    const [searchValue, setSearchValue] = useState('');
    // ** Estados de carga y control de mensajes **
    const [loading, setLoading] = useState(true);
    const [downloading, setDownloading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showWarning, setShowWarning] = useState(false);
    const [controlMensaje, setControlMensaje] = useState(false);
    const [controlMensaje34, setControlMensaje34] = useState(false);
    // ** Estados de modal **
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalFileVisible, setIsModalFileVisible] = useState(false);
    // ** Estados de archivos y subida **
    const [uploadProgress] = useState(0);
    const [fileToUpload, setFileToUpload] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [dataFile, setDataFile] = useState([]);
    const user = useSelector((state) => state.auth.user);
    const userLogin = user.username;

    // ** Cálculo del código del proyecto **
    const tmpCodigo = String(codigo_tarea.codigo_tarea.codigo_tarea).replace(/\./g, '');
    const codigo_proyecto_busqueda = 'tarea_' + tmpCodigo;
    // ** Estados relacionados con la interfaz de usuario **
    const [mostrarPrimerTexto, setMostrarPrimerTexto] = useState(false);
    const [mostrarSegundoTexto, setMostrarSegundoTexto] = useState(false);
    const [instrumento, setInstrumento] = useState(false);
    const [mostrarCheckbox, setMostrarCheckbox] = useState(false);
    const [estadoActEnt, setEstadoActEnt] = useState(false);
    // ** Formulario y referencias **
    const [form] = Form.useForm();
    const inputRef = useRef(null);
    //Video
    const [isModalVisibleAllFile, setIsModalVisibleAllFile] = useState(false);
    const [fileListAllFile, setFileListAllFile] = useState([]);
    const [isSubmittingAllFile, setIsSubmittingAllFile] = useState(false);
    const [formAllFile] = Form.useForm();

    // ** Permisos del usuario **
    const appName = 'file-managerPOA';
    const permissions = useSelector((state) => selectAppPermissions(state, appName));
    const permissionAccess = permissions.priv_access === 'Y'; // Acceso a los botones
    const permissionDelete = permissions.priv_delete === 'Y'; // Elimina el archivo
    const permissionUpdate = permissions.priv_update === 'Y'; // Edita el nombre de la carpeta
    const permissionInsert = permissions.priv_insert === 'Y'; // Subir soporte
    const permissionExport = permissions.priv_export === 'Y'; //Descargar archivo y descargar soporte 
    const permissionPrint = permissions.priv_print === 'Y';   // Crear directorio

    //** Permisos validado check archivos */
    const appName2 = 'file-managerPOA-check';
    const permissions2 = useSelector((state) => selectAppPermissions(state, appName2));
    const permissionUpdate2 = permissions2.priv_update === 'Y';  // Actualizar check archivos
    const permissionPrint2 = permissions2.priv_access === 'Y';   // Acceso a la pantalla
    const permissionDelete2 = permissions2.priv_delete === 'Y';  // Eliminar archivo en check

    //** Permisos para subir varios archivos */
    const appName3 = 'file-managerPOA-File-All';
    const permissions3 = useSelector((state) => selectAppPermissions(state, appName3));
    const permissionAccess3 = permissions3.priv_access === 'Y'; //Acceso a la pantalla
    const permissionInsert3 = permissions3.priv_insert === 'Y'; //Subir varios archivos 
    const permissionUpdate3 = permissions3.priv_update === 'Y'; //Editar archivo
    const permissionDelete3 = permissions3.priv_delete === 'Y'; // Eliminar directorio actual y eliminacion del directorio
    const permissionPrint3 = permissions3.priv_print === 'Y';   // Descargar varios archivos
    const [fileInsetAll, setFileInsetAll] = useState(false);
    const [nameFileAll, setNameFileAll] = useState('');

    //Permisos de clasificación
    const appName4 = 'file-managerPOA-Entrega';
    const permissions4 = useSelector((state) => selectAppPermissions(state, appName4));
    const permissionAccess4 = permissions4.priv_access === 'Y';//Acceso tipo de entrega
    const permissionUpdate4 = permissions4.priv_update === 'Y';//Validar el tipo de entrega

    //Permisos de validadar estado
    const appName5 = 'file-managerPOA-Vaidado';
    const permissions5 = useSelector((state) => selectAppPermissions(state, appName5));
    const permissionAccess5 = permissions5.priv_access === 'Y';//Acceso tipo de entrega
    const permissionUpdate5 = permissions5.priv_update === 'Y';//Validar el tipo de entrega

    //Permisos codigo
    const appName6 = 'file-managerPOA-codigo';
    const permissions6 = useSelector((state) => selectAppPermissions(state, appName6));
    const permissionAccess6 = permissions6.priv_access === 'Y';//Acceso al campo codigo

    //Reemplazo soporte
    const appName7 = 'file-managerPOA-Reemplazo';
    const permissions7 = useSelector((state) => selectAppPermissions(state, appName7));
    const permissionAccess7 = permissions7.priv_access === 'Y';//Acceso al campo codigo
    const permissionInsert7 = permissions7.priv_insert === 'Y';//Acceso al campo codigo
    const [modalOpen, setModalOpen] = useState(false)

    const [isFinalFolder, setIsFinalFolder] = useState(false);
    const pasos = codigo_tarea.codigo_tarea.paso;
    const proyecto = codigo_tarea.codigo_tarea.proyecto || codigo_tarea.codigo_tarea.proyectoBuscar;
    const proyecto25 = codigo_tarea.codigo_tarea.proyecto25;
    const informeVisitas = codigo_tarea.codigo_tarea.informeVisitas;
    const proyectoNoLinkeado = codigo_tarea.codigo_tarea.proyectoNoLinkeado;
    const rutaActividad = codigo_tarea.codigo_tarea.rutaActividad;
    const zonaProyecto = codigo_tarea.codigo_tarea.banderaZonas;
    const poaConExtension = codigo_tarea.codigo_tarea.poaConExtension;
    const [recargarKey, setRecargarKey] = useState(0);
    const banderaCarpetasArchivos = codigo_tarea.codigo_tarea.banderaCarpetasArchivos || false;
    const filtrarrutaNew = codigo_tarea.codigo_tarea.proyectoEdah || false;
    const nuevaRuta = codigo_tarea.codigo_tarea.nuevaRuta || false;
    const rutaInformacionGeneral = codigo_tarea.codigo_tarea.rutaInformacionGeneral || false;
    const [proyectoRutaNew, setProyectoRutaNew] = useState(null);
    const esInformeEDAH = !!proyectoRutaNew;

    //Informe 332
    const [informe332Visible, setInforme332Visible] = useState(false);
    const [openInforme332, setOpenInforme332] = useState(false);
    const abrirInforme332 = () => setOpenInforme332(true);
    const cerrarInforme332 = () => setOpenInforme332(false);

    //Ruta de reemplazo
    const data = codigo_tarea?.codigo_tarea || codigo_tarea;
    const limpiar = (txt) => txt?.toString().replace(/\./g, "");
    const oidMV = data?.medioV?.[0]?.oidMV;
    const remplazo_ruta = `DocumentosPOA/actividad_${limpiar(data.codActividad)}/tarea_${limpiar(data.codigo_tarea)}/${data.key}/medio_verificacion_${oidMV}/`;
    const [selectItemRemplazo, setSelectItemRemplazo] = useState(null);

    const onExpand = (newExpandedKeys) => {
        setExpandedKeys(newExpandedKeys);
        setAutoExpandParent(true);
    };

    const showCreateFolderModal = () => {
        setIsModalVisible(true);
    };

    useEffect(() => {
        if (isModalVisible && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isModalVisible]);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleCreateFolder();
        }
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (nuevaRuta) {
                    const response = await axios.get(`${baseUrl}/api/directorytreepoa?nuevaRuta=${rutaInformacionGeneral}`);
                    const data = response.data;
                    const sortedData = data.map(sortChildren);
                    const filterNodes = (nodes, condition) =>
                        nodes.flatMap(node =>
                            condition(node)
                                ? [node]
                                : node.children
                                    ? filterNodes(node.children, condition)
                                    : []
                        );
                    let filteredData2 = sortedData;
                    if (filtrarrutaNew !== "todos") {
                        filteredData2 = filterNodes(sortedData, node =>
                            node.name.includes(filtrarrutaNew)
                        );
                    }
                    setTreeData(filteredData2);
                }
                else if (!codigo_tarea.codigo_tarea.codigo_tarea) {
                    const response = await axios.get(`${baseUrl}/api/directorytreepoa?codigActividad=${rutaActividad}&codigoTarea=${codigo_tarea.codigo_tarea.nombre}`);
                    const data = response.data;
                    const sortedData = data.map(sortChildren);
                    const filterNodes = (nodes, condition) =>
                        nodes.flatMap(node =>
                            condition(node)
                                ? [node]
                                : node.children
                                    ? filterNodes(node.children, condition)
                                    : []
                        );
                    let filteredData2 = sortedData;
                    if (codigo_tarea.codigo_tarea.linkeado === 2) {
                        filteredData2 = filterNodes(sortedData, node =>
                            node.name.includes(proyectoNoLinkeado)
                        );
                    }
                    setTreeData(filteredData2);
                } else if (!nuevaRuta) {
                    if (!codigo_proyecto_busqueda) {
                        setLoading(false);
                        setShowWarning(true);
                        return;
                    }
                    const tmpcodActividadParametro = String(
                        codigo_tarea.codigo_tarea.codActividad
                    ).replace(/\./g, "");
                    const codActividadParametro = "actividad_" + tmpcodActividadParametro;
                    let data;
                    if (codigo_tarea.codigo_tarea.dataInfraestructura) {
                        const sanitizeTree = nodes =>
                            Array.isArray(nodes)
                                ? nodes.map(node => ({
                                    ...node,
                                    children: sanitizeTree(node.children || [])
                                }))
                                : [];
                        const sanitized = sanitizeTree(codigo_tarea.codigo_tarea.dataInfraestructura);
                        setTreeData(sanitized);
                    } else {
                        let carpetaEliminada = null;
                        const params = { codigoTarea: codigo_proyecto_busqueda, codigActividad: codActividadParametro, };
                        if (codigo_tarea.codigo_tarea.rutaEstructuracion) {
                            params.rutaEstructuracion = codigo_tarea.codigo_tarea.rutaEstructuracion;
                        }
                        const queryString = new URLSearchParams(params).toString();
                        const response = await axios.get(`${baseUrl}/api/directorytreepoa?${queryString}`);
                        const indicador = codigo_tarea.codigo_tarea.key;
                        if (codigo_proyecto_busqueda === 'tarea_221') {
                            if (indicador === 'indicador_32') {
                                setControlMensaje(false)
                                setControlMensaje34(false)
                            } else if (indicador === 'indicador_33') {
                                setControlMensaje(false)
                                setControlMensaje34(false)
                            } else if (indicador === 'indicador_34') {
                                setControlMensaje34(false)
                                setControlMensaje(true)
                                setMostrarPrimerTexto(true)
                            }
                        } else if (indicador === 'indicador_30') {
                            setControlMensaje34(true)
                            setControlMensaje(false)
                            setMostrarSegundoTexto(true)
                        } else {
                            setControlMensaje(false)
                            setControlMensaje34(false)
                        }
                        data = response.data;
                        const getIndicadorChildren = nodes => nodes.flatMap(node => node.typeS === "indicador" && node.name === codigo_tarea.codigo_tarea.key ? node.children : node.children ? getIndicadorChildren(node.children) : []);
                        const filterNodes = (nodes, condition) =>
                            nodes.flatMap(node =>
                                condition(node)
                                    ? [node]
                                    : node.children
                                        ? filterNodes(node.children, condition)
                                        : []
                            );
                        let filteredData2 = getIndicadorChildren(data);
                        if (zonaProyecto) {
                            filteredData2 = filterNodes(filteredData2, node => node.name.includes(zonaProyecto));
                        } else
                            if (banderaCarpetasArchivos) {
                                filteredData2 = filterNodes(data, node => node.name.includes(carpetaEliminada));
                            } else
                                if (codigo_tarea.codigo_tarea.linkeado === 1) {
                                    filteredData2 = filterNodes(filteredData2, node =>
                                        node.name.includes(codigo_tarea.codigo_tarea.ruta)
                                    );
                                } else if (pasos) {
                                    filteredData2 = filterNodes(filteredData2, node =>
                                        node.name.includes(proyecto)
                                    );
                                    filteredData2 = filterNodes(filteredData2, node => node.name === pasos);
                                } else if (poaConExtension) {
                                    const carpetaExtension = filterNodes(response.data, node =>
                                        node.name === "POA con Extensión"
                                    );
                                    filteredData2 = filterNodes(carpetaExtension, node =>
                                        node.name.includes(proyecto)
                                    );

                                } else if (proyecto) {
                                    filteredData2 = filterNodes(filteredData2, node =>
                                        node.name.includes(proyecto)
                                    );
                                } else if (proyecto25) {
                                    filteredData2 = filterNodes(filteredData2, node =>
                                        node.name.includes(proyecto25)
                                    );
                                    filteredData2 = filterP25AndValidFiles(filteredData2);
                                    if (!filteredData2 || filteredData2.length === 0) {
                                        message.warning("No se encontraron archivos validados de infraestructura en la carpeta seleccionada.");
                                        handleClose();
                                        return;
                                    }
                                } else if (informeVisitas) {
                                    const partes = informeVisitas.split("/");
                                    const carpetaFinal = partes[partes.length - 1];  // P01
                                    filteredData2 = obtenerInformesDesde12ConProyecto(filteredData2, carpetaFinal);
                                }
                        if (!filteredData2 || filteredData2.length === 0) {
                            filteredData2 = data;
                        }
                        filteredData2 = ordenarPorFechaAscendente(filteredData2);
                        setTreeData(filteredData2);
                    }
                    setTableParams(prev => ({ ...prev, pagination: { ...prev.pagination } }));
                    setExpandedKeys(prev =>
                        !prev.includes("0") ? [...prev, "0"] : prev
                    );
                }
                if (!expandAll && treeData.length > 0) {
                    const initialKeys = treeData.slice(0, 9).map(item => item.key);
                    setExpandedKeys(initialKeys);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [codigo_tarea, recargarKey, proyecto, pasos, proyecto25, informeVisitas, codigo_proyecto_busqueda]);



    function obtenerInformesDesde12ConProyecto(data, proyectoCode) {
        const informes = [];
        const limiteInicio = proyectoCode === "P25" ? 9 : 12;
        data.forEach((nodo) => {
            if (nodo.children && Array.isArray(nodo.children)) {
                nodo.children.forEach((informe) => {
                    const nombreInforme = informe.name || "";
                    const match = nombreInforme.match(/Informe\s+(\d+)/i);
                    if (!match || parseInt(match[1], 10) < limiteInicio) return;
                    const soporteInfra = (informe.children || []).find((child) =>
                        normalize(child.name).includes("soportes infraestructura")
                    );
                    if (!soporteInfra) return;
                    const implementacion = (soporteInfra.children || []).find(
                        (child) => normalize(child.name) === "implementacion"
                    );
                    if (!implementacion) return;
                    const fao = (implementacion.children || []).find(
                        (child) => normalize(child.name) === "fao"
                    );
                    if (!fao) return;
                    const proyectoFolder = (fao.children || []).find((child) =>
                        normalize(child.name).startsWith(normalize(proyectoCode))
                    );
                    if (!proyectoFolder) return;
                    const archivos = (proyectoFolder.children || []).filter(
                        (c) => c.type === "file"
                    );
                    const fileCount = archivos.length;
                    const informeAplanado = {
                        ...informe,
                        children: [proyectoFolder],
                        fileCount: fileCount,
                    };
                    informes.push(informeAplanado);
                });
            }
        });

        return informes;
    }

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    }

    function filterP25AndValidFiles(tree) {
        return tree
            .map(node => {
                if (node.type === 'file') {
                    const esValidado = node.metadato?.estadovalidacion === 'Validado';
                    const estado = node.metadato?.estado;
                    const estadoValido = estado === 'Infraestructura' || estado === 'Insumos e infraestructura';
                    return (esValidado && estadoValido) ? node : null;
                }

                if (node.type === 'folder' && Array.isArray(node.children)) {
                    const filteredChildren = filterP25AndValidFiles(node.children);
                    if (filteredChildren.length === 0) {
                        return null;
                    }
                    const fileCount = countValidFiles(filteredChildren);
                    return {
                        ...node,
                        children: filteredChildren,
                        fileCount
                    };
                }
                return null;
            })
            .filter(Boolean);
    }

    function countValidFiles(nodes) {
        let count = 0;
        for (const node of nodes) {
            if (node.type === 'file') {
                count += 1;
            } else if (node.type === 'folder' && Array.isArray(node.children)) {
                count += countValidFiles(node.children);
            }
        }
        return count;
    }

    const sortChildren = (node) => {
        if (!node.children || node.children.length === 0) {
            return node;
        }
        node.children.sort((a, b) => {
            if (a.type !== b.type) {
                return a.type === "folder" ? -1 : 1;
            }
            const extractLeadingNumber = (name) => {
                const match = name.match(/^(\d+)/);
                return match ? parseInt(match[0], 10) : null;
            };
            const numA = extractLeadingNumber(a.name);
            const numB = extractLeadingNumber(b.name);
            if (numA !== null && numB !== null) {
                return numA - numB;
            }
            if (numA !== null) return -1;
            if (numB !== null) return 1;
            return a.name.localeCompare(b.name, undefined, { numeric: true });
        });

        node.children = node.children.map(sortChildren);
        return node;
    };

    const handleOkFile = () => {
        if (selectedItem && selectedItem.pathFromClient) {
        } else {
            console.error('selectedItem o pathFromClient es nulo o indefinido.');
        }
        setIsModalFileVisible(true);
        form.resetFields();
    };

    const handleCancelFile = () => {
        form.resetFields();
        setIsModalFileVisible(false);
    };

    const [hover, setHover] = useState(false);

    const handleCustomRequest = async ({
        file,
        onSuccess,
        onError,
        resourceType,
        categoriaUser,
    }) => {
        try {
            if (!file) {
                return onError(new Error("Nombre del soporte es requerido"));
            }
            const nodeRaiz = "DocumentosPOA";
            let tmpRuta = "";
            let projectFolder = "";
            let context = "";
            const rawCodActividad = codigo_tarea?.codigo_tarea?.codActividad;
            const tieneActividad =
                !!rawCodActividad || (rutaActividad && rutaActividad !== "");
            const tieneProyectoEDAH = !!proyectoRutaNew;
            if (tieneActividad) {
                context = "poa";
                let codActividadParametro = "";
                if (rawCodActividad) {
                    const tmpcodActividadParametro = String(rawCodActividad).replace(/\./g, "");
                    codActividadParametro = "actividad_" + tmpcodActividadParametro;
                } else if (rutaActividad) {
                    codActividadParametro = rutaActividad.replace(/^actividad_/, "");
                }
                if (!codActividadParametro || !selectedItem?.pathFromClient) {
                    message.warning("No se pudo determinar la ruta de la actividad (POA).");
                    return onError(new Error("Ruta o actividad no válida."));
                }
                tmpRuta = `${nodeRaiz}/${codActividadParametro}/${selectedItem.pathFromClient}`;
                projectFolder = selectedItem.name;
            } else if (tieneProyectoEDAH) {
                context = `${rutaInformacionGeneral}`;
                tmpRuta = `${nodeRaiz}/${rutaInformacionGeneral}/${proyectoRutaNew}`;
                projectFolder = proyectoRutaNew;
            } else {
                message.warning("No se puede cargar el archivo: no se encontró contexto válido (POA o EDAH).");
                return onError(new Error("Contexto no reconocido."));
            }
            const resourceInfo = await handleAction({
                user: userLogin,
                actionType: "uploadFile",
                nameServer: file.name,
                resourceDetails: {
                    nameResource: file.name,
                    Path: tmpRuta,
                    fatherResource: projectFolder,
                    typeResource: "file",
                    key: `${tmpRuta}/${file.name}`,
                    fullPath: `${tmpRuta}/${file.name}`,
                    resourceType,
                    categoriaUser,
                    context,
                },
            });
            const formData = new FormData();
            formData.append("pathFromClient", tmpRuta);
            formData.append("file", file);
            formData.append("resourceInfo", JSON.stringify(resourceInfo));
            formData.append("categoriaUser", categoriaUser || "Sin categorizar");
            const { data } = await axios.post(`${baseUrl}/api/upload`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true,
            });
            if (data.status === 'success') {
                message.success(`${file.name} cargado correctamente.`);
                const uid = generateRandomUid();
                const newKey = `${selectedItem.key} - ${uid}`;
                const insertedData = data.data;
                const newFileNode = {
                    name: file.name,
                    key: newKey,
                    type: 'file',
                    level: selectedItem.level + 1,
                    path: `${selectedItem.pathFromClient}/${insertedData.serverFileName}`,
                    pathFromClient: selectedItem.pathFromClient,
                    uid,
                    serverFileName: insertedData.serverFileName,
                    isLeaf: true,
                    viewName: file.name,
                    typeS: 'Soporte',
                    resourceType,
                    categoriaUser,
                    metadato: {
                        ...insertedData,
                        detailJSON: JSON.stringify(resourceInfo)
                    }
                };
                setTreeData(prevTreeData =>
                    addFileToTree(prevTreeData, selectedItem.pathFromClient, newFileNode)
                );
                setDataFile(prevDataFile => [
                    ...prevDataFile,
                    {
                        ...insertedData,
                        detailJSON: JSON.stringify(resourceInfo)
                    }
                ]);
                setSelectedItem(prev => {
                    if (prev.pathFromClient === selectedItem.pathFromClient) {
                        const updatedChildren = prev.children ? [...prev.children, newFileNode] : [newFileNode];
                        return {
                            ...prev,
                            children: updatedChildren
                        };
                    }
                    return prev;
                });
                onSuccess("ok");
            } else {
                throw new Error(`Error en la carga de ${file.name}`);
            }
        } catch (error) {
            console.error("Upload error:", error);
            message.error(`${file.name} Error en la carga, vuelve a intentarlo.`);
            onError(error);
        }
    };


    const handleFormSubmit = async () => {
        try {
            await form.validateFields();
            setIsSubmitting(true);
            const tituloForm = form.getFieldValue('titulo');
            const resourceType = form.getFieldValue('resourceType');
            const titulo = tituloForm || editRecord?.nameResource;
            let categoriaUser = form.getFieldValue('categoriaUser');
            if (!categoriaUser || categoriaUser === 'undefined') {
                categoriaUser = "Sin categorizar";
            }
            if (fileToUpload) {
                const fileExtension = fileToUpload.name.split('.').pop();
                const newFileName = `${titulo}.${fileExtension}`;
                const renamedFile = new File([fileToUpload], decodeURIComponent(newFileName), { type: fileToUpload.type });
                handleCustomRequest({
                    file: renamedFile,
                    onSuccess: () => {
                        setFileList([]);
                        setFileToUpload(null);
                        setIsModalFileVisible(false);
                        setIsSubmitting(false);
                    },
                    onError: (error) => {
                        console.error('Error en la subida:', error);
                        setIsSubmitting(false);
                    },
                    resourceType,
                    categoriaUser,
                });
            } else if (editRecord) {
                const newDetailJSON = {
                    ...(JSON.parse(editRecord.detailJSON || '{}')),
                    nameResource: titulo,
                    resourceType,
                };
                const response = await handleAction({
                    user: userLogin,
                    actionType: 'updateFileMetadata',
                    resourceDetails: {
                        oid: editRecord.oid,
                        nameResource: titulo,
                        resourceType,
                        detailJSON: JSON.stringify(newDetailJSON)
                    }
                });
                if (response.status === 'success') {
                    message.success('Soporte actualizado correctamente.');
                    setIsModalFileVisible(false);
                    setFileToUpload(null);
                    setIsSubmitting(false);
                } else {
                    throw new Error('No se pudo actualizar la información del soporte.');
                }
            }
        } catch (errorInfo) {
            console.error('Error en validación o envío:', errorInfo);
            setIsSubmitting(false);
        }
    };

    const searchInTree = (node, searchTerm, expandedKeys) => {
        let foundMatch = false;
        if (node.viewName.toLowerCase().includes(searchTerm.toLowerCase())) {
            node.highlighted = true;
            foundMatch = true;
            node.title = (
                <span>
                    {node.viewName.replace(
                        new RegExp(`(${searchTerm})`, 'gi'),
                        (text, match) => (
                            <span style={{ backgroundColor: 'yellow', color: '#AAA' }}>{match}</span>
                        )
                    )}
                </span>
            );
        } else {
            node.highlighted = false;
        }
        if (node.children && node.children.length > 0) {
            node.children.forEach(childNode => {
                if (searchInTree(childNode, searchTerm, expandedKeys)) {
                    expandedKeys.push(node.key);
                    foundMatch = true;
                }
            });
        }
        return foundMatch;
    };

    const onChange = (e) => {
        setSearchValue(e.target.value);
    };

    useEffect(() => {
        if (treeData.length > 0) {
            setExpandedKeys(prevExpandedKeys => {
                const nodeZeroKey = treeData[0]?.key;
                const updatedExpandedKeys = prevExpandedKeys.includes(nodeZeroKey)
                    ? prevExpandedKeys
                    : [...prevExpandedKeys, nodeZeroKey];
                return updatedExpandedKeys;
            });
        }
    }, [treeData]);

    const onClickBuscar = () => {
        if (searchValue.trim() === '') {
            return;
        }
        const clonedTreeData = cloneDeep(treeData);
        const newExpandedKeys = [];
        clonedTreeData.forEach(node => searchInTree(node, searchValue, newExpandedKeys));
        const nodeZeroKey = treeData[0]?.key;
        if (nodeZeroKey && !newExpandedKeys.includes(nodeZeroKey)) {
            newExpandedKeys.push(nodeZeroKey);
        }
        setTreeData(clonedTreeData);
        setExpandedKeys(newExpandedKeys);
    };

    const reglasValidacion = {
        "tarea_134/indicador_16/medio_verificacion_15/": [
            "Homologación MER-ICO",
            "Instrumento MER"
        ],
        "tarea_418/indicador_77/medio_verificacion_72/": [
            "OTROSI"
        ]
    };

    const pathsConOrdenFecha = new Set([
        "tarea_221/indicador_34/medio_verificacion_29/",
        "tarea_214/indicador_30/medio_verificacion_25/",
        "tarea_223/indicador_36/medio_verificacion_31/",
        "tarea_234/indicador_43/medio_verificacion_38/",
        "tarea_313/indicador_52/medio_verificacion_47/",
        "tarea_323/indicador_58/medio_verificacion_53/"
    ]);

    const pathChecklist = new Set(["tarea_214/indicador_30/medio_verificacion_25/"]);

    const informe332Segments = [
        "tarea_332",
        "indicador_60",
        "medio_verificacion_55",
    ];


    function ordenarPorFechaAscendente(archivos) {
        const meses = [
            "enero", "febrero", "marzo", "abril", "mayo", "junio",
            "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
        ];

        const rutaObjetivo = "medio_verificacion_25/";

        const limpiarNombre = (name) => {
            const partes = name.split("-");
            if (partes.length < 2) return name;
            return partes.slice(1).join("-");
        };

        const getFechaArchivo = (nameLimpio) => {
            const match = nameLimpio.match(/^(\d{8})_/);
            if (!match) return null;
            const raw = match[1];
            const day = raw.slice(0, 2);
            const month = raw.slice(2, 4);
            const year = raw.slice(4, 8);
            return new Date(`${year}-${month}-${day}T00:00:00`);
        };

        const parsearFechaCarpeta = (nombre) => {
            const regex = /([a-zA-ZñÑ]+).*?(\d{4})/;
            const match = nombre.match(regex);
            if (!match) return null;
            const mes = match[1].toLowerCase();
            const year = parseInt(match[2]);
            let mesIndex = meses.findIndex(m => mes.startsWith(m));
            if (mesIndex === -1) mesIndex = 0;
            return { year, mes: mesIndex };
        };

        const archivosOrdenados = archivos
            .map((item) => {
                if (item.type === "folder" && Array.isArray(item.children)) {
                    return {
                        ...item,
                        children: ordenarPorFechaAscendente(item.children),
                    };
                }
                return item;
            })
            .sort((a, b) => {
                if (a.type === "folder" && b.type !== "folder") return -1;
                if (a.type !== "folder" && b.type === "folder") return 1;
                if (a.type === "folder" && b.type === "folder") {
                    const pathActual = a.path || "";
                    if (pathActual.includes(rutaObjetivo)) {
                        const fechaA = parsearFechaCarpeta(a.name);
                        const fechaB = parsearFechaCarpeta(b.name);
                        if (fechaA && fechaB) {
                            if (fechaA.year !== fechaB.year) {
                                return fechaA.year - fechaB.year;
                            }
                            return fechaA.mes - fechaB.mes;
                        }
                    }
                    return a.name.localeCompare(b.name, "es", { numeric: true, sensitivity: "base" });
                }
                const nombreALimpio = limpiarNombre(a.name);
                const nombreBLimpio = limpiarNombre(b.name);
                const fechaA = getFechaArchivo(nombreALimpio);
                const fechaB = getFechaArchivo(nombreBLimpio);
                if (fechaA && fechaB) {
                    const diff = fechaA - fechaB;
                    if (diff !== 0) return diff;
                    const restoA = nombreALimpio.substring(9);
                    const restoB = nombreBLimpio.substring(9);
                    return restoA.localeCompare(restoB, "es", { numeric: true, sensitivity: "base" });
                }
                if (!fechaA && !fechaB) {
                    return nombreALimpio.localeCompare(nombreBLimpio, "es", { numeric: true, sensitivity: "base" });
                }
                if (!fechaA) return 1;
                if (!fechaB) return -1;
            });
        return archivosOrdenados;
    }

    const handleSelect = async (selectedKeys, info) => {
        const selectedNode = info.node;
        const nombreNodoRaiz = codigo_proyecto_busqueda;
        const basePath = selectedNode.path.split("/").slice(0, 3).join("/") + "/";
        const esInstrumento = selectedNode.path.includes("tarea_419") ? true : (reglasValidacion[basePath]?.includes(selectedNode.serverFileName) || false);
        setFileInsetAll(true);
        if (nuevaRuta) {
            setProyectoRutaNew(basePath)
        } else
            if (basePath.includes("tarea_214")) {
                setEstadoActEnt(true);
                setNameFileAll("Actas_entrega");
            } else if (basePath.includes("tarea_221")) {
                setEstadoActEnt(true);
                setNameFileAll("Visitas_de_acompañamiento");
            } else if (basePath.includes("tarea_221") || basePath.includes("tarea_223")) {
                setNameFileAll("Informe");
            }
        setInstrumento(esInstrumento);
        const path = selectedNode?.path || '';
        const tieneRutaValida = Array.from(pathChecklist).some(ruta =>
            path.includes(ruta)
        );

        const isInforme332 = informe332Segments.every(seg =>
            path.includes(seg)
        );
        setInforme332Visible(isInforme332);

        setMostrarCheckbox(tieneRutaValida && permissionPrint2);
        const ordenarNecesario = [...pathsConOrdenFecha].some(path => selectedNode.path.includes(path));
        if (ordenarNecesario && Array.isArray(selectedNode.children)) {
            selectedNode.children = ordenarPorFechaAscendente(selectedNode.children);
        }

        if (selectedNode && Array.isArray(selectedNode.children) && selectedNode.children.length > 0) {
            const hasFolderChild = selectedNode.children.some(child => child.type === 'folder');
            if (hasFolderChild) {
                setIsFinalFolder(false);
            } else {
                setIsFinalFolder(true);
            }
        } else {
            setIsFinalFolder(true);
        }
        if (selectedNode.name === nombreNodoRaiz) {
            setRootNodeSelected(true);
            setSelectedItem(null);
        } else {
            setSelectedItem({
                ...selectedNode,
                pathFromClient: selectedNode.path
            });
            setRootNodeSelected(false);

            if (selectedNode.type === 'file') {
                fetchFileUrl(selectedNode);
            }
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: selectedNode.children ? selectedNode.children.length : 0,
                    current: 1
                }
            });
        }
    };

    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 30,
            total: 0,
        },
    });

    const handleEditFolder = async (path, nuevoNombre) => {
        const nodeRaiz = "DocumentosPOA";
        const regex = /^[a-zA-Z0-9 _áéíóúÁÉÍÓÚñÑ.,()-´]+$/;
        if (!regex.test(nuevoNombre)) {
            message.error("El nombre contiene caracteres no permitidos.");
            return;
        }
        if (!selectedItem) {
            message.warning("No hay carpeta seleccionada para editar.");
            return;
        }
        const rawCodActividad = codigo_tarea?.codigo_tarea?.codActividad;
        const tieneActividad = !!rawCodActividad || (rutaActividad && rutaActividad !== "");
        const tieneProyectoEDAH = !!proyectoRutaNew;
        let oldPath = "";
        let tmpRuta = "";
        let fatherResource = "";
        let codActividadParametro = "";

        try {
            if (tieneActividad) {
                if (rawCodActividad) {
                    const tmpcodActividadParametro = String(rawCodActividad).replace(/\./g, "");
                    codActividadParametro = "actividad_" + tmpcodActividadParametro;
                } else if (rutaActividad) {
                    codActividadParametro = rutaActividad.replace(/^actividad_/, "");
                }
                const lastSlashIndex = path.lastIndexOf("/");
                const basePath = lastSlashIndex >= 0 ? path.substring(0, lastSlashIndex) : "";
                const shouldAssignPath = !path.includes("actividad_");
                tmpRuta = shouldAssignPath
                    ? `${codActividadParametro}/${basePath ? `${basePath}/` : ""}${nuevoNombre}`
                    : path.replace(/[^/]+$/, nuevoNombre);
                oldPath = shouldAssignPath
                    ? `${codActividadParametro}/${path}`
                    : path;
                const fatherlastSlashIndex = tmpRuta.lastIndexOf("/");
                fatherResource = fatherlastSlashIndex >= 0 ? tmpRuta.substring(0, fatherlastSlashIndex) : "";
                tmpRuta = tmpRuta.replace(/\/{2,}/g, "/");
                oldPath = oldPath.replace(/\/{2,}/g, "/");
                fatherResource = fatherResource.replace(/\/{2,}/g, "/");
            }
            else if (tieneProyectoEDAH) {
                const cleanProyecto = (proyectoRutaNew || "").replace(/\/$/, "").trim();
                const esSubcarpeta = path.includes("/");
                if (esSubcarpeta) {
                    const lastSlashIndex = path.lastIndexOf("/");
                    const basePath = path.substring(0, lastSlashIndex);
                    const lastSegmentOld = path.substring(lastSlashIndex + 1);
                    oldPath = `${rutaInformacionGeneral}/${cleanProyecto}/${basePath ? `${basePath}/` : ""}${lastSegmentOld}`;
                    tmpRuta = `${rutaInformacionGeneral}/${cleanProyecto}/${basePath ? `${basePath}/` : ""}${nuevoNombre}`;
                    fatherResource = `${rutaInformacionGeneral}/${cleanProyecto}/${basePath}`.replace(/\/$/, "");
                } else {
                    oldPath = `${rutaInformacionGeneral}/${path}`;
                    tmpRuta = `${rutaInformacionGeneral}/${nuevoNombre}`;
                    fatherResource = `${rutaInformacionGeneral}`;
                }
                oldPath = oldPath.replace(/\/{2,}/g, "/");
                tmpRuta = tmpRuta.replace(/\/{2,}/g, "/");
                fatherResource = fatherResource.replace(/\/{2,}/g, "/");
            }
            if (!tmpRuta || !oldPath) {
                message.warning("No se pudo determinar la ruta para editar.");
                return;
            }
            const resourceInfo = await handleAction({
                user: userLogin,
                actionType: "updateFolder",
                nameServer: nuevoNombre,
                resourceDetails: {
                    nameResource: nuevoNombre,
                    Path: tmpRuta,
                    fatherResource: `${nodeRaiz}/${fatherResource}`.replace(/\/{2,}/g, "/"),
                    typeResource: "folder",
                    key: `${nodeRaiz}/${tmpRuta}`.replace(/\/{2,}/g, "/"),
                    fullPath: `${nodeRaiz}/${tmpRuta}`.replace(/\/{2,}/g, "/"),
                    resourceType: tieneProyectoEDAH ? "Folder POA" : "Folder POA",
                },
            });
            const formData = new FormData();
            formData.append("ruta", oldPath);
            formData.append("nuevoNombre", nuevoNombre);
            formData.append("nodeRaiz", nodeRaiz);
            formData.append("resourceInfo", JSON.stringify(resourceInfo));
            const response = await axios.post(`${baseUrl}/api/editNameDirectories`, formData, {
                headers: { "Content-Type": "multipart/form-data; charset=UTF-8" },
            });
            if (response.status === 200) {
                const tmpRutaResponse = (response.data && response.data.nuevoPath) || tmpRuta;
                const newPath =
                    tieneActividad
                        ? tmpRutaResponse.replace(/actividad_\d+\//, "")
                        : tmpRutaResponse;
                const wasUpdated = await updateNodeName(nuevoNombre, newPath);
                if (wasUpdated) {
                    await reloadTree();
                    message.success("Nombre de la carpeta actualizado correctamente.");
                } else {
                    setSelectedItem((prev) => prev ? { ...prev, viewName: nuevoNombre, name: nuevoNombre } : prev);
                    message.success("Nombre actualizado.");
                }
            } else {
                message.error("Error al actualizar el nombre de la carpeta. Inténtalo de nuevo.");
            }
        } catch (error) {
            message.error("Error al actualizar el nombre de la carpeta. Inténtalo de nuevo.");
        } finally {
            console.groupEnd();
        }
    };

    const updateNodeName = async (newName, newPath) => {
        if (!selectedItem) {
            return;
        }
        const updatedTreeData = cloneDeep(treeData);
        const updateNode = (nodes, keyToUpdate, newName, newPath) => {
            for (let node of nodes) {
                if (node.key === keyToUpdate) {
                    node.name = newName;
                    node.serverFileName = newName;
                    node.viewName = newName;
                    node.key = newPath;
                    if (node.path) {
                        node.path = newPath;
                    }
                    if (node.children) {
                        updateChildrenPaths(node.children, newPath);
                    }
                    return true;
                }
                if (node.children) {
                    if (updateNode(node.children, keyToUpdate, newName, newPath)) {
                        return true;
                    }
                }
            }
            return false;
        };

        const updateChildrenPaths = (children, newPath) => {
            children.forEach((child) => {
                const newChildPath = `${newPath}/${child.name}`;
                child.path = newChildPath;
                child.key = newChildPath;
                if (child.children) {
                    updateChildrenPaths(child.children, newChildPath);
                }
            });
        };

        const wasUpdated = updateNode(updatedTreeData, selectedItem.key, newName, newPath);

        if (wasUpdated) {
            setTreeData([...updatedTreeData]);
            const updatedSelectedItem = {
                ...selectedItem,
                name: newName,
                key: newPath,
                path: newPath,
                pathFromClient: newPath,
                viewName: newName,
            };
            setSelectedItem(updatedSelectedItem);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    current: 1,
                },
            });
            setIsEditing(false);
        } else {
            message.error('No se pudo actualizar el nodo.');
        }
    };

    const toggleEditMode = () => {
        setIsEditing(!isEditing);
        if (!isEditing) {
            setNewName(selectedItem.viewName);
        }
    };

    const handleNameChange = (e) => {
        let value = e.target.value.normalize('NFC');
        const regex = /^[a-zA-Z0-9 _áéíóúÁÉÍÓÚñÑ.,()-´]+$/;
        if (regex.test(value) || value === '') {
            setNewFolderName(value);
        } else {
            message.error('El nombre contiene caracteres no permitidos 1.');
        }
    };

    const handleEditNameChange = (e) => {
        const value = e.target.value.normalize('NFC');
        const regex = /^[a-zA-Z0-9 _áéíóúÁÉÍÓÚñÑ.,()-´]+$/;
        if (regex.test(value) || value === '') {
            setNewName(value);
        } else {
            message.error('El nombre contiene caracteres no permitidos.');
        }
    };

    const cancelEditMode = () => {
        setIsEditing(false);
        setNewName(selectedItem.viewName);
    };

    const generateRandomUid = () => {
        return Math.random().toString(36).substr(2, 9);
    };

    const addFileToTree = (treeData, pathFromClient, fileToAdd, parentKey) => {
        const updatedTreeData = JSON.parse(JSON.stringify(treeData));
        const addToNode = (nodes, path, file, parentKey) => {
            for (let node of nodes) {
                if (node.path === path) {
                    if (!node.children) {
                        node.children = [];
                    }
                    const newKey = `${node.key} - ${file.uid}`;
                    node.children.push({
                        name: file.name,
                        key: newKey,
                        type: 'file',
                        level: node.level + 1,
                        path: `${path}/${file.serverFileName}`,
                        pathFromClient: file.pathFromClient,
                        uid: file.uid,
                        serverFileName: file.serverFileName,
                        viewName: file.name,
                        typeS: 'Soporte',
                        isLeaf: true,
                    });
                    return true;
                }
                if (node.children && addToNode(node.children, path, file, parentKey)) {
                    return true;
                }
            }
            return false;
        };
        addToNode(updatedTreeData, pathFromClient, fileToAdd, parentKey);
        return updatedTreeData;
    };

    const deleteNodeFromTree = (nodes, pathToDelete) => {
        let parentKey = null;
        const deleteNodeRecursively = (nodes, pathToDelete) => {
            return nodes
                .map(node => {
                    if (node && node.path === pathToDelete) {
                        return null;
                    }
                    if (Array.isArray(node.children)) {
                        const updatedChildren = deleteNodeRecursively(node.children, pathToDelete);
                        if (updatedChildren.length === 0) {
                            parentKey = node.key;
                            return { ...node, children: [] };
                        }
                        return { ...node, children: updatedChildren };
                    }
                    return node;
                })
                .filter(node => node !== null);
        };

        const updatedTreeData = deleteNodeRecursively(nodes, pathToDelete);
        return { updatedTreeData, parentKey };
    };

    const findNodeByKeyF = (nodes, key) => {
        for (const node of nodes) {
            if (node.key === key) {
                return node;
            }
            if (node.children) {
                const foundNode = findNodeByKeyF(node.children, key);
                if (foundNode) {
                    return foundNode;
                }
            }
        }
        return null;
    };

    const handleDeleteFile = async (file) => {
        try {
            const nodeRaiz = "DocumentosPOA";
            let tmpFilepathserver = "";
            let tmpFull = "";
            let context = "";
            let codActividadParametro = "";
            let fatherResource = "";

            const rawCodActividad = codigo_tarea?.codigo_tarea?.codActividad;
            const tieneActividad =
                !!rawCodActividad || (rutaActividad && rutaActividad !== "");
            const tieneProyectoEDAH = !!proyectoRutaNew;
            if (tieneActividad) {
                context = "poa";
                if (rawCodActividad) {
                    const tmpcodActividadParametro = String(rawCodActividad).replace(/\./g, "");
                    codActividadParametro = "actividad_" + tmpcodActividadParametro;
                } else if (rutaActividad) {
                    codActividadParametro = rutaActividad.replace(/^actividad_/, "");
                }
                let subPath = "";
                if (file.pathFromClient && file.pathFromClient !== "undefined") {
                    subPath = file.pathFromClient;
                } else if (file.path && file.path !== "undefined") {
                    const cleanPath = file.path.replace(/^DocumentosPOA[\\/]/, "").trim();
                    subPath = cleanPath;
                }
                if (subPath && subPath.endsWith(file.serverFileName)) {
                    subPath = subPath.replace(file.serverFileName, "").replace(/\/$/, "");
                }
                tmpFull = subPath
                    ? `${codActividadParametro}/${subPath}/${file.serverFileName}`
                    : `${codActividadParametro}/${file.serverFileName}`;
                tmpFilepathserver = limpiarCodigoArchivoEnRuta(tmpFull);
                fatherResource = selectedItem?.name || "";
            } else if (tieneProyectoEDAH) {
                context = rutaInformacionGeneral;
                tmpFull = `/${rutaInformacionGeneral}/${proyectoRutaNew}/${file.serverFileName}`;
                tmpFilepathserver = encodeURIComponent(tmpFull);
                fatherResource = proyectoRutaNew;
            } else {
                message.warning("No se pudo determinar el tipo de archivo (POA, EDAH o IPPTA).");
                return;
            }
            const resourceInfo = await handleAction({
                user: userLogin,
                actionType: "deleteFile",
                nameServer: file.serverFileName,
                resourceDetails: {
                    nameResource: file.serverFileName,
                    Path: `${nodeRaiz}/${tmpFilepathserver}`,
                    fatherResource,
                    typeResource: "file",
                    key: file.path || tmpFull,
                    fullPath: `${nodeRaiz}/${tmpFull}`,
                    context,
                },
            });
            const deleted = await deleteFile(tmpFilepathserver, nodeRaiz, resourceInfo);
            if (!deleted) {
                console.warn("El servidor no eliminó el archivo.");
                return;
            }
            message.success("Archivo eliminado correctamente.");
            const filePathNode =
                file.path
                    ? file.path.substring(0, file.path.lastIndexOf("/") + 1) + file.serverFileName
                    : `${proyectoRutaNew}/${file.serverFileName}`;

            const { updatedTreeData, parentKey } = deleteNodeFromTree(treeData, filePathNode);
            setTreeData(updatedTreeData);
            if (parentKey) {
                const parentNode = findNodeByKey(updatedTreeData, parentKey);
                if (parentNode) setSelectedItem(parentNode);
            } else {
                const rootNode = updatedTreeData[0];
                if (rootNode) setSelectedItem(rootNode);
            }
            if (selectedItem && Array.isArray(selectedItem.children)) {
                const updatedChildren = selectedItem.children.filter(
                    (child) => child.uid !== file.uid
                );
                setSelectedItem({ ...selectedItem, children: updatedChildren });
                setTableParams((prev) => ({
                    ...prev,
                    pagination: {
                        ...prev.pagination,
                        total: updatedChildren.length,
                        current: 1,
                    },
                }));
            }
            setDataFile((prevDataFile) =>
                prevDataFile.filter((item) => item.oid !== file.metadato?.oid)
            );
        } catch (error) {
            console.error("Error en handleDeleteFile:", error);
            message.error("Error inesperado al eliminar el archivo.");
        }
    };

    const deleteFile = async (filePath, nodeRaiz, data) => {
        const formData = new FormData();
        formData.append('filePath', filePath);
        formData.append('nodeRaiz', nodeRaiz);
        formData.append('resourceInfo', JSON.stringify(data));
        try {
            const response = await axios.post(`${baseUrl}/api/delete-file`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response.data.status === 'success') {
                return true;
            } else {
                console.error('[deleteFile] Error:', response.data.message);
                return false;
            }
        } catch (error) {
            console.error('[deleteFile] Axios error:', error);
            return false;
        }
    };


    const extractDateFromFilename = (filename) => {
        const dateMatch = filename.match(/(\d{2})(\d{2})(\d{4})/);
        if (dateMatch) {
            const [_, day, month, year] = dateMatch;
            return new Date(`${year}-${month}-${day}`);
        }
        return new Date(0);
    };

    const handleTableChange = (pagination) => {
        setTableParams({
            ...tableParams,
            pagination
        });
    };

    function limpiarCodigoArchivoEnRuta(fullPath) {
        const partes = fullPath.split('/');
        const archivo = partes.pop();
        const nuevoNombreArchivo = archivo.replace(/^\d{13,}-/, '');
        return [...partes, nuevoNombreArchivo].join('/');
    }

    const handleChecklistChange = async (checked, record) => {
        try {
            const nodeRaiz = 'DocumentosPOA';
            const tmpcodActividadParametro = String(codigo_tarea.codigo_tarea.codActividad).replace(/\./g, '');
            const codActividadParametro = nodeRaiz + '/actividad_' + tmpcodActividadParametro + `/${record.path}`;
            const fullPathLimpio = limpiarCodigoArchivoEnRuta(codActividadParametro);
            const cleanName = record.name.replace(/^\d+-/, '');
            let payload = {};
            if (record.metadato) {
                payload = {
                    oid: record.metadato.oid,
                    nameResource: cleanName,
                    fullPath: `${fullPathLimpio}`,
                    user: record.metadato.user || 'admin',
                    state: 1,
                    typeAction: record.metadato.typeAction,
                    dateTime: record.metadato.dateTime,
                    detailJSON: record.metadato.detailJSON,
                    validado: checked ? 2 : 1,
                    validado_user: userLogin,
                    fecha_validacion: checked ? new Date().toISOString().slice(0, 10) : null,

                };
            } else {
                const resourceInfo = await handleAction({
                    user: 'admin',
                    actionType: 'uploadFile',
                    nameServer: cleanName,
                    resourceDetails: {
                        nameResource: record.name,
                        Path: `${fullPathLimpio}`,
                        fatherResource: selectedItem.name,
                        typeResource: 'file',
                        key: `${selectedItem.pathFromClient}/${record.name}`,
                        fullPath: `${fullPathLimpio}`,
                        resourceType: nameFileAll
                    }
                });
                payload =
                {
                    nameResource: cleanName,
                    fullPath: `${fullPathLimpio}`,
                    user: 'admin',
                    state: 1,
                    typeAction: "uploadFile",
                    dateTime: new Date().toISOString(),
                    detailJSON: JSON.stringify(resourceInfo),
                    validado: checked ? 2 : 1,
                    validado_user: userLogin,
                    fecha_validacion: checked ? new Date().toISOString().slice(0, 10) : null,
                }
            }
            const res = await enviarHistorico(payload);
            if (res) {
                if (checked) {
                    message.success('El documento fue validado correctamente');
                } else {
                    message.info('Desmarcación del documento realizada correctamente');
                }
                if (record.metadato) {
                    record.metadato.validado = checked ? 2 : 1;
                    record.metadato.validado_user = userLogin;
                } else {
                    record.metadato = {
                        ...payload,
                        oid: res.oid,
                    }
                }
                const updatedTree = JSON.parse(JSON.stringify(treeData));
                setTreeData(updatedTree);
            }
        } catch (error) {
            console.error('Error al marcar checklist:', error);
        }
    };

    const columnaCodigoUnico = {
        title: 'Código',
        key: 'codUnico',
        width: 100,
        align: 'center',
        render: (_, record) => {
            if (record.type !== 'file') return null;
            return record.metadato?.codUnico || '-';
        },
    };

    const [editRecord, setEditRecord] = useState(null);

    const handleEdit = (record) => {
        setEditRecord(record);
        setIsModalFileVisible(true);
        const nombreSinPrefijo = record.name?.replace(/^\d{13}-/, '');
        const tipo = record.resourceType || 'Acta_entrega';
        form.setFieldsValue({
            titulo: nombreSinPrefijo || '',
            resourceType: tipo,
        });
        setFileList([]);
        setFileToUpload(null);
    };

    const columnaChecklist = {
        title: 'Validado',
        key: 'checklist',
        width: 100,
        align: 'center',
        render: (text, record) => {
            if (record.type !== 'file') return null;
            const validado = Number(record.metadato?.validado);
            return (
                <input
                    type="checkbox"
                    checked={validado === 2}
                    disabled={!permissionUpdate2}
                    onChange={e => {
                        if (permissionUpdate2) {
                            handleChecklistChange(e.target.checked, record);
                        }
                    }}
                />
            );
        },
    };

    const opcionesEstado = [
        "Sin categorizar",
        "Infraestructura",
        "Materiales",
        "Insumos",
        "Insumos e infraestructura",
        "No infraestructura"
    ];

    const columnaCategoria = {
        title: 'Clasificación',
        key: 'estado',
        width: 180,
        align: 'center',
        render: (_, record) => {
            const estadoActual = record.metadato?.estado || "Sin categorizar";
            const isValidado = record.metadato?.estadovalidacion === 'Validado';
            const handleMenuClick = async ({ key }) => {
                if (isValidado) {
                    message.warning('No puedes modificar la categoría porque el archivo ya está validado.');
                    return;
                }
                const id = record.metadato?.oid;
                const tipoEntrega = key || "Sin categorizar";

                const result = await ActualizarTipoEntrega(id, tipoEntrega);
                if (result.success) {
                    message.success('Tipo de categoría actualizado correctamente');
                    if (record.metadato) {
                        record.metadato.estado = key;
                    } else {
                        record.metadato = { estado: key };
                    }
                    const updatedTree = JSON.parse(JSON.stringify(treeData));
                    setTreeData(updatedTree);
                } else {
                    message.error(result.message);
                }
            };
            const menu = {
                items: opcionesEstado.map((estado) => ({
                    key: estado,
                    label: (
                        <span
                            style={{
                                fontWeight: estado === estadoActual ? 'bold' : 'normal',
                                backgroundColor: estado === estadoActual ? '#e6f7ff' : 'inherit',
                                display: 'block',
                                padding: '4px 12px',
                            }}
                        >
                            {estado}
                        </span>
                    ),
                })),
                onClick: handleMenuClick,
            };
            const isSinCategorizar = estadoActual === "Sin categorizar";
            const backgroundColor = isSinCategorizar ? '#1890ff2b' : '#52c41a3d';
            if (permissionUpdate4 && !isValidado) {
                return (
                    <Dropdown menu={menu} trigger={['click']}>
                        <Button
                            size="small"
                            style={{
                                color: '#000',
                                backgroundColor,
                                borderColor: backgroundColor,
                            }}
                        >
                            {estadoActual}
                        </Button>
                    </Dropdown>
                );
            } else {
                return (
                    <span
                        style={{
                            display: 'inline-block',
                            padding: '4px 12px',
                            backgroundColor,
                            border: `1px solid ${backgroundColor}`,
                            borderRadius: 4,
                            color: '#000',
                            opacity: isValidado ? 0.6 : 1,
                        }}
                    >
                        {estadoActual}
                    </span>
                );
            }
        },
    };

    const columnaValidarEstado = {
        title: 'Validar estado',
        key: 'estadovalidacion',
        width: 140,
        align: 'center',
        render: (_, record) => {
            if (record.type !== 'file') return null;
            const estadoActual = record.metadato?.estadovalidacion || 'Sin validar';
            const isValidado = estadoActual === 'Validado';
            const handleToggleValidacion = async () => {
                if (!permissionUpdate5) return;
                const id = record.metadato?.oid;
                const nuevoEstado = isValidado ? 'Sin validar' : 'Validado';
                const result = await ValidarEstadoActa(id, nuevoEstado);
                if (result.success) {
                    message.success('Estado de validación actualizado correctamente');
                    if (record.metadato) {
                        record.metadato.estadovalidacion = nuevoEstado;
                    } else {
                        record.metadato = { estadovalidacion: nuevoEstado };
                    }
                    const updatedTree = JSON.parse(JSON.stringify(treeData));
                    setTreeData(updatedTree);
                } else {
                    message.error(result.message);
                }
            };
            const backgroundColor = !isValidado ? '#1890ff2b' : '#52c41a3d';
            if (permissionUpdate5) {
                return (
                    <Button
                        type="primary"
                        size="small"
                        onClick={handleToggleValidacion}
                        style={{
                            color: '#000',
                            backgroundColor,
                            borderColor: backgroundColor,
                        }}
                    >
                        {isValidado ? "Validado" : "Sin validar"}
                    </Button>
                );
            } else if (permissionAccess5) {
                return (
                    <Button
                        type="default"
                        size="small"
                        disabled
                        style={{
                            color: '#000',
                            backgroundColor,
                            borderColor: backgroundColor,
                        }}
                    >
                        {isValidado ? "Validado" : "Sin validar"}
                    </Button>
                );
            } else {
                return null;
            }
        },
    };

    const columnas = [
        ...(isFinalFolder
            ? [
                ...(permissionAccess4 ? [columnaCategoria] : []),
                ...(permissionAccess5 ? [columnaValidarEstado] : []),
                ...(permissionAccess6 ? [columnaChecklist] : []),
                ...(permissionPrint2 ? [columnaCodigoUnico] : []),
            ]
            : []
        )
    ];

    const columnasCategoria = [
        {
            title: 'Categoría',
            dataIndex: 'categoria',
            key: 'categoria',
            align: 'center',
            width: 150,
            render: (_, record) => {
                const categoria = record.metadato?.categoriaUser || '-';
                return <span>{categoria}</span>;
            }
        }
    ];

    const columnasBase = [
        {
            title: 'Opciones',
            key: 'action',
            width: 150,
            align: 'left',
            fixed: 'left',
            render: (text, record) => (
                <Space size={4}>
                    {permissionExport && permissionAccess && (
                        <Tooltip title="Descargar">
                            <Popconfirm
                                title='Descargar archivos'
                                description="¿Segur@ que quieres descargar el directorio?"
                                onConfirm={() => handleDescargar(record)}
                                okText="Sí"
                                cancelText="No"
                                okButtonProps={{
                                    loading: loading,
                                }}
                            >
                                <Button
                                    type="link"
                                    icon={<DownloadOutlined style={{ fontSize: '1.1rem' }} />}
                                    rel="noopener noreferrer"
                                    className="ico_table"
                                />
                            </Popconfirm>
                        </Tooltip>
                    )}
                    {record.type === 'file' && (
                        <>
                            {(permissionUpdate3 && permissionAccess3) && (
                                <Tooltip title="Editar">
                                    <Button
                                        type="link"
                                        icon={<EditOutlined style={{ fontSize: '1.1rem' }} />}
                                        onClick={() => handleEdit(record)}
                                        className="ico_table"
                                    />
                                </Tooltip>
                            )}

                            {(
                                (estadoActEnt && (permissionDelete2 && Number(record.metadato?.validado) !== 2)) ||
                                (!estadoActEnt && permissionDelete && permissionAccess)
                            ) && (
                                    <Tooltip title="Eliminar archivo">
                                        <Popconfirm
                                            title="Eliminación de archivo"
                                            description="¿Segur@ que quieres eliminar este archivo?"
                                            onConfirm={() => handleDeleteFile(record)}
                                            okText="Sí"
                                            cancelText="No"
                                            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                        >
                                            <Button
                                                type="link"
                                                danger

                                                icon={<DeleteOutlined style={{ fontSize: '1.1rem' }} />}
                                                className="ico_table"
                                            />
                                        </Popconfirm>
                                    </Tooltip>
                                )}
                            <Tooltip title="Visualizar el archivo">
                                <Button
                                    onClick={() => fetchFileUrl(record)}
                                    style={{
                                        border: 'none',
                                        background: 'none',
                                        cursor: 'pointer',
                                        padding: '10px',
                                    }}
                                >
                                    <EyeOutlined style={{ fontSize: '24px', color: '#08c' }} />
                                </Button>
                            </Tooltip>

                        </>
                    )}

                    {record.canDelete && permissionDelete3 && permissionAccess3 && (
                        <Tooltip title="Eliminar del directorio">
                            <Popconfirm
                                title='Eliminación de directorio'
                                description="¿Segur@ que quieres eliminar este directorio, no podras revertir esta operación?"
                                onConfirm={() => handleDeleteFolder(record.path, record)}
                                okText="Sí"
                                cancelText="No"
                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            >
                                <Button
                                    type="link"
                                    danger
                                    icon={<DeleteOutlined />}
                                    className='me-2 p-0'
                                />
                            </Popconfirm>
                        </Tooltip>
                    )
                    }
                </Space>
            ),
        },
        ...(mostrarCheckbox ? columnas : []),
        ...(isFinalFolder ? [
            {
                title: 'N°',
                key: 'index',
                width: 60,
                align: 'center',
                render: (text, record, index) => {
                    return record.type === 'file' ? index + 1 : null;
                },
            }] : []),
        {
            title: 'Documento',
            dataIndex: 'name',
            key: 'key',
            width: 400,
            sorter: (a, b) => {
                const dateA = extractDateFromFilename(a.viewName);
                const dateB = extractDateFromFilename(b.viewName);
                return dateB - dateA;
            },
            render: (text, record) => {
                const maxLength = 50;
                const maxLengthTooltip = 200;
                let truncatedTitle;
                if (record.type === 'file') {
                    truncatedTitle = processFileName(record.viewName, maxLength);
                } else {
                    truncatedTitle = record.viewName;
                }
                const truncatedTooltip = processFileName(record.viewName, maxLengthTooltip);
                return (
                    <Tooltip title={truncatedTooltip} placement="right">
                        <span>
                            {record.type === 'folder' ? <FolderOutlined /> : <FileOutlined />}
                            {` ${truncatedTitle}`}
                        </span>
                    </Tooltip>
                );
            }
        },
        {
            title: 'Formato',
            key: 'extension',
            width: 100,
            align: 'center',
            render: (text, record) => {
                if (typeof record.name === 'string') {
                    if (record.type === 'folder' && typeof record.fileCount !== 'undefined') {
                        const pathContainsTarea = record.path.includes("tarea_221/indicador_34/");
                        const fileCountToDisplay = pathContainsTarea ? (record.fileCount - record.filePhoto === 0 ? record.fileCount : record.fileCount - record.filePhoto) : record.fileCount;
                        return (
                            <>
                                <Tooltip title="Cantidad de archivos que contiene la carpeta">
                                    <span>Folder</span> <span></span>
                                    <Badge
                                        className="site-badge-count-109"
                                        count={fileCountToDisplay}
                                        overflowCount={9999}
                                        style={{
                                            backgroundColor: '#52c41a',
                                        }}
                                    />
                                </Tooltip>
                            </>
                        );
                    } else if (record.type === 'folder' && record.children.some(child => child.type === 'file')) {
                        return (
                            <>
                                <Tooltip title="Cantidad de archivos que contiene la carpeta">
                                    <span>Folder</span> <span>  </span>
                                    <Badge
                                        className="site-badge-count-109"
                                        count={record.children.length}
                                        style={{
                                            backgroundColor: '#52c41a',
                                        }}
                                    />
                                </Tooltip>
                            </>
                        );
                    } else {
                        if (record.type === 'folder') {
                            return 'Folder';
                        } else {
                            const fileNameParts = record.name.split('.');
                            return fileNameParts.length > 1 ? fileNameParts.pop() : 'Archivo';
                        }
                    }
                } else {
                    return 'Desconocido';
                }
            },
        },
        ...(isFinalFolder ? [
            {
                title: 'Tipo de soporte',
                dataIndex: 'name',
                align: 'center',
                key: 'key',
                width: 150,
                render: (text, record) => {
                    let tipoSoporte = '-';

                    if (record.metadato && record.metadato.detailJSON) {
                        try {
                            const detailData = JSON.parse(record.metadato.detailJSON || '{}');
                            tipoSoporte = detailData?.resourceData?.resourceType || 'No reportado';
                        } catch (error) {
                            console.error('Error al parsear detailJSON:', error);
                            tipoSoporte = '-';
                        }
                    }

                    return <span>{tipoSoporte}</span>;
                }
            },
            ...(mostrarCheckbox ? columnasCategoria : []),
            {
                title: 'Usuario',
                dataIndex: 'name',
                align: 'center',
                key: 'key',
                width: 150,
                render: (text, record) => {
                    const usuario = record.metadato ? record.metadato.user : '-';
                    return (
                        <span>
                            {usuario}
                        </span>
                    );
                }
            },
            {
                title: 'Creación',
                dataIndex: 'name',
                key: 'key',
                align: 'center',
                width: 150,
                render: (text, record) => {
                    const fecha = record.metadato ? record.metadato.dateTime : '-';
                    const creacion = fecha !== '-'
                        ? new Date(fecha).toLocaleDateString('sv-SE')
                        : '-';
                    return (
                        <span>{creacion}</span>
                    );
                }
            }
        ] : []),
    ];

    const renderSelectedFiles = () => {
        if (selectedItem && selectedItem.type === 'folder') {
            return (
                <Table
                    dataSource={selectedItem.children}
                    pagination={false}
                    onChange={handleTableChange}
                    scroll={{
                        y: 340,
                    }}
                    columns={columnasBase}
                />
            );
        } else {
            return (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <WarningOutlined style={{ color: 'red', marginRight: '8px', fontSize: '2rem' }} />
                    <h3>Seleccione el siguiente nivel del árbol para ver los archivos.</h3>
                </div>
            );
        }
    };

    const reloadTree = async () => {
        setLoading(true);
        try {
            let codActividadParametro = '';
            const rawCodActividad = codigo_tarea?.codigo_tarea?.codActividad;

            if (rawCodActividad) {
                const tmpcodActividadParametro = String(rawCodActividad).replace(/\./g, '');
                codActividadParametro = 'actividad_' + tmpcodActividadParametro;
            } else if (rutaActividad) {
                codActividadParametro = rutaActividad.replace(/^actividad_/, '');
            }
            const response = await axios.get(`${baseUrl}/api/directorytreepoa?codigActividad=${codActividadParametro}&codigoTarea=${codigo_proyecto_busqueda}`);
            const data = response.data;
            const mv = data[0].children[0].children[0].name;
            const indicador = codigo_tarea.codigo_tarea.key;
            const fullPath = "DocumentosPOA/" + codActividadParametro + "/" + codigo_proyecto_busqueda + "/" + indicador + "/" + mv;
            const documents = await fetchPoaDataByPath(fullPath);
            setDataFile(documents);
            const getIndicadorChildren = (nodes) => {
                return nodes.flatMap(node => {
                    if (node.typeS === 'indicador') {
                        return node.children;
                    } else if (node.children && node.children.length > 0) {
                        return getIndicadorChildren(node.children);
                    }
                    return [];
                });
            };
            const filteredData = getIndicadorChildren(data);
            setTreeData(filteredData);
            if (selectedItem) {
                const existingNode = findNodeByKeyF(filteredData, selectedItem.key);
                if (existingNode) {
                    setSelectedItem(existingNode);
                    setExpandedKeys([existingNode.key]);
                } else {
                    setSelectedItem(null);
                    setExpandedKeys([filteredData[0]?.key]);
                }
            } else {
                setExpandedKeys([filteredData[0]?.key]);
            }
        } catch (error) {
            console.error('Error fetching file tree:', error);
        } finally {
            setLoading(false);
        }
    };

    const onLimpiarBusqueda = () => {

        setActiveButton(null);
        setSearchValue('');
        setRootNodeSelected(true);
        setSelectedItem(null);
        setLoading(true);
        setShowWarning(false);
        setControlMensaje(false);
        setControlMensaje34(false);
        setMostrarPrimerTexto(false);
        setMostrarSegundoTexto(false);
        setRecargarKey(prev => prev + 1);
    };

    const handleDeleteFolder = async (path, data) => {
        const nodeRaiz = "DocumentosPOA";
        try {
            const rawCodActividad = codigo_tarea?.codigo_tarea?.codActividad;
            const tieneActividad = !!rawCodActividad || (rutaActividad && rutaActividad !== "");
            const tieneProyectoEDAH = !!proyectoRutaNew;
            let codActividadParametro = "";
            let tmpRuta = "";
            let fatherResource = "";
            let nameServer = data.serverFileName && data.serverFileName.trim() !== "" ? data.serverFileName : data.name;
            if (tieneActividad) {
                if (rawCodActividad) {
                    const tmpcodActividadParametro = String(rawCodActividad).replace(/\./g, "");
                    codActividadParametro = "actividad_" + tmpcodActividadParametro;
                } else if (rutaActividad) {
                    codActividadParametro = rutaActividad.replace(/^actividad_/, "");
                }
                tmpRuta = `${codActividadParametro}/${path}`.replace(/\/{2,}/g, "/");
                fatherResource = `${nodeRaiz}/${codActividadParametro}`;
            }
            else if (tieneProyectoEDAH) {
                const cleanProyecto = proyectoRutaNew.replace(/\/$/, "").trim();
                if (path === cleanProyecto || !path.includes("/")) {
                    tmpRuta = `${rutaInformacionGeneral}/${cleanProyecto}`;
                    fatherResource = `${rutaInformacionGeneral}`;
                } else {
                    tmpRuta = `${rutaInformacionGeneral}/${cleanProyecto}/${path}`.replace(/\/{2,}/g, "/");
                    const fatherlastSlashIndex = tmpRuta.lastIndexOf("/");
                    fatherResource = `${rutaInformacionGeneral}/${cleanProyecto}`;
                    if (fatherlastSlashIndex > -1) {
                        fatherResource = tmpRuta.substring(0, fatherlastSlashIndex);
                    }
                }
            } else {
                message.warning("No se pudo determinar el contexto (POA o EDAH).");
                return;
            }
            const resourceInfo = await handleAction({
                user: userLogin,
                actionType: "deleteFolder",
                nameServer,
                resourceDetails: {
                    nameResource: nameServer,
                    Path: tmpRuta,
                    fatherResource: `${nodeRaiz}/${fatherResource}`.replace(/\/{2,}/g, "/"),
                    typeResource: "folder",
                    key: data.path,
                    fullPath: `${nodeRaiz}/${tmpRuta}`.replace(/\/{2,}/g, "/"),
                    resourceType: tieneProyectoEDAH ? "Folder EDAH" : "Folder POA",
                },
            });
            const formData = new FormData();
            formData.append("dirPath", tmpRuta);
            formData.append("nodeRaiz", nodeRaiz);
            formData.append("resourceInfo", JSON.stringify(resourceInfo));
            const response = await axios.post(`${baseUrl}/api/delete-directory`, formData);
            if (response.status === 200) {
                const { updatedTreeData, parentKey } = deleteNodeFromTree(treeData, path);
                setTreeData(updatedTreeData);
                if (parentKey) {
                    const parentNode = findNodeByKey(updatedTreeData, parentKey);
                    if (parentNode) setSelectedItem(parentNode);
                } else {
                    const rootNode = updatedTreeData[0];
                    if (rootNode) setSelectedItem(rootNode);
                }
                if (selectedItem) {
                    const updatedChildren = selectedItem.children?.filter(
                        (child) => child.path !== path
                    );
                    setSelectedItem({ ...selectedItem, children: updatedChildren });
                }
                setTableParams((prev) => ({
                    ...prev,
                    pagination: {
                        ...prev.pagination,
                        current: 1,
                    },
                }));
                message.success("Directorio y sus contenidos eliminados correctamente.");
            } else {
                message.error("Error al eliminar el directorio. Inténtalo de nuevo.");
            }
        } catch (error) {
            console.error("[handleDeleteFolder] Error general:", error);
            message.error("Error al eliminar el directorio. Inténtalo de nuevo.");
        } finally {
            console.groupEnd();
        }
    };


    const findNodeByKey = (nodes, key) => {
        for (const node of nodes) {
            if (node.key === key) {
                return node;
            }
            if (node.children) {
                const found = findNodeByKey(node.children, key);
                if (found) return found;
            }
        }
        return null;
    };

    const findNode = (nodes, path) => {
        for (let node of nodes) {
            if (node.path === path) {
                return node;
            } else if (node.children) {
                const foundNode = findNode(node.children, path);
                if (foundNode) return foundNode;
            }
        }
        return null;
    };

    const titleRenderer = (node) => {
        const maxLength = 20;
        let decodedFileName;
        let nombre;
        let truncatedTitle;
        if (node.type === 'folder') {
            nombre = node.viewName;
            truncatedTitle = truncateText(nombre, maxLength);;
        } else {
            decodedFileName = decodeURIComponent(node.viewName);
            nombre = cleanFileName(decodedFileName);
            truncatedTitle = truncateText(nombre, maxLength);
        }

        return (
            <Tooltip title={nombre} placement="right" style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                <span
                    style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}
                    className={node.highlighted ? 'highlightedNode' : ''}
                >
                    {truncatedTitle}
                </span>
            </Tooltip>
        );
    };

    const fetchFileUrl = (record) => {
        try {
            const rawCodActividad = codigo_tarea?.codigo_tarea?.codActividad;
            const tieneActividad =
                !!rawCodActividad || (rutaActividad && rutaActividad !== "");
            const tieneProyectoEDAH = !!proyectoRutaNew;

            let codActividadParametro = "";
            let fullPath = "";
            if (tieneActividad) {
                if (rawCodActividad) {
                    const tmpcodActividadParametro = String(rawCodActividad).replace(/\./g, "");
                    codActividadParametro = "actividad_" + tmpcodActividadParametro;
                } else if (rutaActividad) {
                    codActividadParametro = rutaActividad.replace(/^actividad_/, "");
                }
                const relativePath = record.path || record.fullPath || record.nameResource;
                fullPath = `${baseUrl}/DocumentosFAO/DocumentosPOA/${codActividadParametro}/${relativePath}`;
            } else if (tieneProyectoEDAH) {
                const projectPath =
                    proyectoRutaNew || record.pathFromClient || record.path || "";

                const cleanProjectPath = projectPath.replace(/^\/|\/$/g, "");

                fullPath = `${baseUrl}/DocumentosFAO/DocumentosPOA/${rutaInformacionGeneral}/${cleanProjectPath}/${record.serverFileName}`;
            } else {
                message.warning("No se pudo determinar el tipo de archivo.");
                return;
            }
            window.open(fullPath, "_blank", "noopener,noreferrer");
        } catch (error) {
            console.error("Error en fetchFileUrl:", error);
            message.error("Error al intentar abrir el archivo.");
        }
    };

    const filterEmptyFolders = (treeData) => {
        const isEmptyFinalFolder = (node) => {
            if (node.type !== 'folder') {
                return false;
            }
            if (!node.children || node.children.length === 0) {
                return true;
            }
            const allSubfoldersEmpty = node.children.every(child => isEmptyFinalFolder(child));
            return allSubfoldersEmpty;
        };
        const filterTree = (nodes) => {
            return nodes
                .map(node => {
                    const filteredChildren = node.children ? filterTree(node.children) : [];
                    if (node.type === 'folder') {
                        const shouldKeep = isEmptyFinalFolder(node) || filteredChildren.length > 0;
                        return shouldKeep ? { ...node, children: filteredChildren } : null;
                    }
                    return null;
                })
                .filter(node => node !== null);
        };
        const filteredTreeData = filterTree(treeData);
        return filteredTreeData;
    };

    const handleAction = async ({ user, actionType, nameServer, resourceDetails }) => {
        const logEntry = logAction(user, actionType, nameServer, resourceDetails);
        return logEntry
    };

    const filterFolders = () => {
        const hasFiles = (node) => {
            if (node.type === 'file') return true;
            if (node.children && node.children.length > 0) {
                return node.children.some(child => hasFiles(child));
            }

            return false;
        };
        const stack = [...treeData];
        const foldersToRemove = new Set();
        while (stack.length > 0) {
            const node = stack.pop();
            if (node.type === 'folder') {
                if (node.children) {
                    node.children.forEach(child => stack.push(child));
                    if (!hasFiles(node)) {
                        foldersToRemove.add(node);
                    }
                }
            }
        }

        const filterTree = (nodes) => {
            return nodes
                .map(node => {
                    const filteredChildren = node.children ? filterTree(node.children) : [];
                    if (node.type === 'folder') {
                        const shouldKeep = node === treeData[0] || !foldersToRemove.has(node);
                        return shouldKeep ? { ...node, children: filteredChildren } : null;
                    }
                    return node;
                })
                .filter(node => node !== null);
        };
        const filteredTreeData = filterTree(treeData);
        return filteredTreeData;
    };

    const handleFilterEmptyFolders = () => {
        const filteredData = filterEmptyFolders(treeData);
        const sortedData = filteredData.map(sortChildren);
        setTreeData(sortedData);
        setActiveButton('emptyFolders');
    };

    const handleFilterFolders = () => {
        const filteredData = filterFolders(treeData);
        const sortedData = filteredData.map(sortChildren);
        setTreeData(sortedData);
        setActiveButton('folders');
    };

    const treeContainerStyle = {
        height: '500px',
        maxHeight: '90%',
        overflowY: 'auto',
        border: '1px solid #d9d9d9',
        padding: '0px',
        boxSizing: 'border-box',
        zIndex: 11,
    };

    const handleCreateFolder = async () => {
        try {
            const nodeRaiz = "DocumentosPOA";
            const regex = /^[a-zA-Z0-9 _áéíóúÁÉÍÓÚñÑ.,()-´]+$/;
            if (!newFolderName.trim()) {
                message.warning("Debes ingresar un nombre para la carpeta.");
                return;
            }
            if (!regex.test(newFolderName)) {
                message.error("El nombre contiene caracteres no permitidos.");
                return;
            }
            if (!selectedItem) {
                message.warning("No hay una carpeta seleccionada.");
                return;
            }
            const rawCodActividad = codigo_tarea?.codigo_tarea?.codActividad;
            const tieneActividad = !!rawCodActividad || (rutaActividad && rutaActividad !== "");
            const tieneProyectoEDAH = !!proyectoRutaNew;
            let codActividadParametro = "";
            let tmpRuta = "";
            let fatherResource = "";
            if (tieneActividad) {
                if (rawCodActividad) {
                    const tmpcodActividadParametro = String(rawCodActividad).replace(/\./g, "");
                    codActividadParametro = "actividad_" + tmpcodActividadParametro;
                } else if (rutaActividad) {
                    codActividadParametro = rutaActividad.replace(/^actividad_/, "");
                }

                const parentPath = selectedItem.path || "";
                tmpRuta = `${codActividadParametro}/${parentPath}`.replace(/\/{2,}/g, "/");
                fatherResource = `${nodeRaiz}/${tmpRuta}`;
            }
            else if (tieneProyectoEDAH) {
                const cleanProyecto = proyectoRutaNew.replace(/\/$/, "").trim();
                if (selectedItem.path === cleanProyecto || !selectedItem.path) {
                    tmpRuta = `${rutaInformacionGeneral}/${cleanProyecto}`;
                    fatherResource = `${nodeRaiz}/${rutaInformacionGeneral}/${cleanProyecto}`;
                } else {
                    tmpRuta = `${rutaInformacionGeneral}/${cleanProyecto}/${selectedItem.path}`.replace(/\/{2,}/g, "/");
                    fatherResource = `${nodeRaiz}/${tmpRuta}`;
                }
            } else {
                message.warning("No se pudo determinar el contexto (POA o EDAH).");
                return;
            }
            const response = await checkFolderName(tmpRuta, newFolderName, nodeRaiz);
            if (response.data.status === "error") {
                message.error(response.data.message);
                return;
            }
            const resourceInfo = await handleAction({
                user: userLogin,
                actionType: "createFolder",
                nameServer: newFolderName,
                resourceDetails: {
                    nameResource: newFolderName,
                    Path: tmpRuta,
                    fatherResource,
                    typeResource: "folder",
                    key: `${tmpRuta}/${newFolderName}`.replace(/\/{2,}/g, "/"),
                    fullPath: `${nodeRaiz}/${tmpRuta}/${newFolderName}`.replace(/\/{2,}/g, "/"),
                    resourceType: tieneProyectoEDAH ? `Folder ${rutaInformacionGeneral}` : "Folder POA",
                },
            });
            await createFolder(tmpRuta, newFolderName, nodeRaiz, resourceInfo);
            message.success("Carpeta creada exitosamente");
            const parentPath = selectedItem.path || "";
            addNodeToTree(parentPath, newFolderName);
            const updatedNode = findNode(treeData, parentPath);
            if (updatedNode) {
                setSelectedItem((prevSelectedItem) => {
                    if (prevSelectedItem.path === updatedNode.path) {
                        const updatedChildren = [
                            ...updatedNode.children,
                            {
                                name: newFolderName,
                                key: `${parentPath}/${newFolderName}`,
                                path: `${parentPath}/${newFolderName}`,
                                type: "folder",
                                isLeaf: false,
                                children: [],
                                viewName: newFolderName,
                                canDelete: true,
                            },
                        ];
                        return {
                            ...updatedNode,
                            children: updatedChildren,
                            pathFromClient: updatedNode.path,
                        };
                    }
                    return prevSelectedItem;
                });
            }
            setIsModalVisible(false);
            setNewFolderName("");
        } catch (error) {
            console.error("[handleCreateFolder] Error:", error);
            message.error("Ocurrió un error al crear la carpeta. Verifique el nombre o permisos.");
        }
    };

    useEffect(() => {
        renderSelectedFiles();
    }, [dataFile]);

    const addNodeToTree = (path, newFolderName) => {
        const updatedTreeData = cloneDeep(treeData);
        const addNode = (nodes, pathToUpdate, newFolderName) => {
            return nodes.map(node => {
                if (node.path === pathToUpdate) {
                    const children = node.children || [];
                    const newNode = {
                        name: newFolderName,
                        key: `${pathToUpdate}/${newFolderName}`,
                        path: `${pathToUpdate}/${newFolderName}`,
                        type: 'folder',
                        isLeaf: false,
                        children: [],
                        edit: true,
                        canDelete: true,
                        viewName: newFolderName,
                        typeS: 'Desconocido',
                    };

                    return {
                        ...node,
                        children: [...children, newNode],
                    };
                } else if (node.children) {
                    return {
                        ...node,
                        children: addNode(node.children, pathToUpdate, newFolderName),
                    };
                }
                return node;
            });
        };
        const newTreeData = addNode(updatedTreeData, path, newFolderName);
        setTreeData(newTreeData);
    };

    const typeS = selectedItem?.typeS || '';
    const formattedTypeS = typeS
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/^\w/, c => c.toUpperCase());
    const { codActividad, nameActividad, codigo_tarea: codigoTarea, tarea, indicador } = codigo_tarea.codigo_tarea;
    let medioVerificacion = "Medio de Verificación";
    if (codigo_tarea && codigo_tarea.codigo_tarea && Array.isArray(codigo_tarea.codigo_tarea.medioV)) {
        const medioVArray = codigo_tarea.codigo_tarea.medioV;
        const medioVerificaciones = medioVArray.map(item => item.medioVerificacion);
        if (medioVerificaciones.length > 0) {
            medioVerificacion = medioVerificaciones.join(', ');

        }
    }

    const handleDescargar = async (node) => {
        setDownloading(true);
        const nodeRaiz = "DocumentosPOA";
        const rawCodActividad = codigo_tarea?.codigo_tarea?.codActividad;
        const tieneActividad =
            !!rawCodActividad || (rutaActividad && rutaActividad !== "");
        const tieneProyectoEDAH = !!proyectoRutaNew;
        let tmpRuta = "";
        let codActividadParametro = "";
        try {
            if (tieneActividad) {
                if (rawCodActividad) {
                    const tmpcodActividadParametro = String(rawCodActividad).replace(/\./g, "");
                    codActividadParametro = "actividad_" + tmpcodActividadParametro;
                } else if (rutaActividad) {
                    codActividadParametro = rutaActividad.replace(/^actividad_/, "");
                }

                tmpRuta = `${codActividadParametro}/${node.path}`.replace(/\/{2,}/g, "/");
            }
            else if (tieneProyectoEDAH) {
                const cleanProyecto = (proyectoRutaNew || "").replace(/\/$/, "").trim();
                let innerPath = node.path?.replace(/\\/g, "/").replace(/^\/+/, "").trim();
                if (innerPath.startsWith(`${cleanProyecto}/`)) {
                    innerPath = innerPath.replace(`${cleanProyecto}/`, "");
                }
                if (node.level === 0 || node.path === cleanProyecto) {
                    tmpRuta = `${rutaInformacionGeneral}/${cleanProyecto}`;
                }
                else {
                    tmpRuta = `${rutaInformacionGeneral}/${cleanProyecto}/${innerPath}`;
                }
                tmpRuta = tmpRuta.replace(/\/{2,}/g, "/").replace(/\/$/, "");
            }
            if (!tmpRuta) {
                message.warning("No se pudo determinar la ruta de descarga.");
                setDownloading(false);
                return;
            }

            const rutaNormalizada = tmpRuta
                .normalize("NFC")
                .split("/")
                .map(segment => encodeURIComponent(segment))
                .join("/");
            const formData = new FormData();
            formData.append("ruta", rutaNormalizada);
            formData.append("nodeRaiz", nodeRaiz);
            const response = await axios.post(`${baseUrl}/api/descargar-archivos`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                responseType: "blob",
            });
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            if (node.type === "folder") {
                a.download = `${node.viewName}.zip`;
            } else {
                const contentDisposition = response.headers["content-disposition"];
                let filename = node.viewName;
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?(.+?)"?$/);
                    if (match && match[1]) {
                        filename = decodeURIComponent(match[1]);
                    }
                }
                filename = filename.replace(/^\d{6,}-/, "");
                a.download = filename;
            }
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            message.success("Descarga completa de archivos");
        } catch (error) {
            message.error("❌ Error al descargar archivos");
        } finally {
            setDownloading(false);
        }
    };

    const showModalAllFile = () => setIsModalVisibleAllFile(true);
    const handleCancelAllFile = () => {
        setIsModalVisibleAllFile(false);
        setFileListAllFile([]);
        formAllFile.resetFields();
    };

    const handleUploadMultipleFileAll = async (file, resourceType) => {
        const esInformeEDAH = !!proyectoRutaNew;
        try {
            const nodeRaiz = "DocumentosPOA";
            let codActividadParametro = "";
            const rawCodActividad = codigo_tarea?.codigo_tarea?.codActividad;
            let tmpRuta = "";
            let fullPath = "";
            let fatherResource = "";
            let tipoRecurso = resourceType;
            if (esInformeEDAH) {
                const cleanProyecto = (proyectoRutaNew || "").replace(/\/$/, "").trim();
                tmpRuta = `${rutaInformacionGeneral}/${cleanProyecto}`;
                fullPath = `${nodeRaiz}/${tmpRuta}/${file.name}`;
                fatherResource = `${nodeRaiz}/${tmpRuta}`;
                tipoRecurso = `Soporte ${rutaInformacionGeneral}`;
            }
            else {
                if (rawCodActividad) {
                    const tmpcodActividadParametro = String(rawCodActividad).replace(/\./g, "");
                    codActividadParametro = "actividad_" + tmpcodActividadParametro;
                } else if (rutaActividad) {
                    codActividadParametro = rutaActividad.replace(/^actividad_/, "");
                }
                tmpRuta = `${codActividadParametro}/${selectedItem.pathFromClient}`;
                fullPath = `${nodeRaiz}/${tmpRuta}/${file.name}`;
                fatherResource = `${nodeRaiz}/${codActividadParametro}/${selectedItem.pathFromClient}`;
            }
            const resourceInfo = await handleAction({
                user: userLogin,
                actionType: "uploadFile",
                nameServer: file.name,
                resourceDetails: {
                    nameResource: file.name,
                    Path: tmpRuta,
                    fatherResource,
                    typeResource: "file",
                    key: `${selectedItem.pathFromClient}/${file.name}`,
                    fullPath,
                    resourceType: tipoRecurso,
                },
            });
            const formData = new FormData();
            formData.append("pathFromClient", `${nodeRaiz}/${tmpRuta}`);
            formData.append("file", file);
            formData.append("resourceInfo", JSON.stringify(resourceInfo));
            const response = await axios.post(`${baseUrl}/api/upload`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            const data = response.data;
            if (data.status === "success") {
                const insertedData = data.data;
                const uid = generateRandomUid();
                const newKey = `${selectedItem.key} - ${uid}`;

                const newFileNode = {
                    name: file.name,
                    key: newKey,
                    type: "file",
                    level: selectedItem.level + 1,
                    path: `${selectedItem.pathFromClient}/${insertedData.serverFileName}`,
                    pathFromClient: selectedItem.pathFromClient,
                    uid,
                    serverFileName: insertedData.serverFileName,
                    isLeaf: true,
                    viewName: file.name,
                    typeS: esInformeEDAH ? `${rutaInformacionGeneral}` : "Soporte",
                    resourceType: tipoRecurso,
                    metadato: {
                        ...insertedData,
                        detailJSON: JSON.stringify(resourceInfo),
                    },
                };
                setTreeData((prevTreeData) =>
                    addFileToTree(prevTreeData, selectedItem.pathFromClient, newFileNode)
                );
                setDataFile((prevDataFile) => [
                    ...prevDataFile,
                    {
                        ...insertedData,
                        detailJSON: JSON.stringify(resourceInfo),
                    },
                ]);
                setSelectedItem((prev) => {
                    if (prev.pathFromClient === selectedItem.pathFromClient) {
                        const updatedChildren = prev.children
                            ? [...prev.children, newFileNode]
                            : [newFileNode];
                        return {
                            ...prev,
                            children: updatedChildren,
                        };
                    }
                    return prev;
                });
                message.success(`Archivo "${file.name}" subido correctamente`);
            } else {
                throw new Error(`Error al subir el archivo: ${file.name}`);
            }
        } catch (error) {
            console.error("Upload multiple error:", error);
            message.error(`Error al subir "${file.name}"`);
        }
    };

    const handleFormSubmitAllFile = async () => {
        if (!fileListAllFile || fileListAllFile.length === 0) {
            message.error("Por favor, cargue al menos un archivo.");
            return;
        }
        try {
            const values = !esInformeEDAH ? await formAllFile.validateFields() : {};
            const resourceType = esInformeEDAH ? `Soporte ${rutaInformacionGeneral}` : values.resourceType;
            setIsSubmittingAllFile(true);
            const validFiles = fileListAllFile
                .filter((fileWrapper) => fileWrapper.originFileObj)
                .map((fileWrapper) => fileWrapper.originFileObj);
            if (validFiles.length === 0) {
                message.error("No se encontraron archivos válidos para subir.");
                return;
            }
            for (const file of validFiles) {
                const decodedFileName = decodeURIComponent(file.name);
                const renamedFile = new File([file], decodedFileName, { type: file.type });
                await handleUploadMultipleFileAll(renamedFile, resourceType);
            }
            setFileListAllFile([]);
            formAllFile.resetFields();
            setIsModalVisibleAllFile(false);
            message.success(`${validFiles.length} archivo(s) cargado(s) correctamente.`);
        } catch (err) {
            console.error("Error al subir archivos:", err);
            message.error("Error al subir los archivos.");
        } finally {
            setIsSubmittingAllFile(false);
        }
    };

    const draggerPropsAllFile = {
        name: 'files',
        multiple: true,
        maxCount: 50,
        fileList: fileListAllFile,
        beforeUpload: (file, fileList) => {
            return false;
        },
        onChange: (info) => {
            let fileList = [...info.fileList];
            if (draggerPropsAllFile.maxCount) {
                fileList = fileList.slice(-draggerPropsAllFile.maxCount);
            }
            fileList = fileList.filter(file => {
                if (file.error) {
                    message.error(`Error con ${file.name}: ${file.error}`);
                    return false;
                }
                return true;
            });
            setFileListAllFile(fileList);
        },
        onDrop: (e) => {
            const droppedFiles = e.dataTransfer.files;
            if (droppedFiles.length > 0) {
                const newFiles = Array.from(droppedFiles).map(file => ({
                    uid: Math.random().toString(36).substr(2, 9),
                    name: file.name,
                    status: 'done',
                    originFileObj: file,
                }));
                setFileListAllFile(prev => {
                    const combined = [...prev, ...newFiles];
                    // Aplica límite si existe
                    return draggerPropsAllFile.maxCount
                        ? combined.slice(-draggerPropsAllFile.maxCount)
                        : combined;
                });
                message.success(`${droppedFiles.length} archivo(s) agregado(s)`);
            }
        },
        accept: "*",
    };



    return (
        <>
            <Drawer
                open={isVisible}
                onClose={handleClose}
                title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span className="custom-modal-title" style={{ color: '#FFF' }}>
                            Medios de verificación
                        </span>
                        <Button
                            type="text"
                            onClick={handleClose}
                            icon={<CloseOutlined style={{ fontSize: '20px', color: '#FFF' }} />}
                        />
                    </div>
                }
                placement="right"
                width="100%"
                closable={false}
                destroyOnHidden
                styles={{
                    body: {
                        padding: 0,
                        height: '100%',
                        overflow: 'hidden',
                    },
                }}
            >

                <Layout style={{ height: '100vh' }}>
                    <Sider

                        collapsed={isCollapsed}
                        onCollapse={(value) => setIsCollapsed(value)}
                        width={350}
                        style={{ background: '#fff', borderRight: '1px solid #f0f0f0' }}
                    >
                        <div style={{ padding: 16 }}>
                            <Button
                                icon={<MenuOutlined />}
                                onClick={() => setIsCollapsed(!isCollapsed)}
                                block
                            >
                            </Button>
                            <div style={{ marginBottom: 5, marginTop: 5 }}>
                                <Input
                                    placeholder="Buscar"
                                    value={searchValue}
                                    onChange={onChange}
                                    suffix={
                                        <>
                                            <Tooltip title="Buscar archivos por nombre" placement="top">
                                                <Button
                                                    type="primary"
                                                    icon={<SearchOutlined />}
                                                    onClick={onClickBuscar}
                                                    style={{
                                                        marginRight: 8,
                                                        visibility: isCollapsed ? 'hidden' : 'visible',
                                                    }}
                                                />
                                            </Tooltip>
                                            <Tooltip title="Restablecer filtros de carpetas" placement="top">
                                                <Button
                                                    icon={<ReloadOutlined />}
                                                    onClick={onLimpiarBusqueda}
                                                    style={{
                                                        visibility: isCollapsed ? 'hidden' : 'visible',
                                                    }}
                                                />
                                            </Tooltip>
                                            <Tooltip title="Filtrar carpetas sin archivos" placement="top">
                                                <Button
                                                    icon={<FileExclamationOutlined />}
                                                    onClick={handleFilterEmptyFolders}
                                                    style={{
                                                        backgroundColor: activeButton === 'emptyFolders' ? 'lightblue' : 'initial',
                                                        borderColor: activeButton === 'emptyFolders' ? 'blue' : 'initial',
                                                        visibility: isCollapsed ? 'hidden' : 'visible',
                                                    }}
                                                />
                                            </Tooltip>
                                            <Tooltip title="Filtrar carpetas con archivos" placement="top">
                                                <Button
                                                    icon={<FileZipOutlined />}
                                                    onClick={handleFilterFolders}
                                                    style={{
                                                        backgroundColor: activeButton === 'folders' ? 'lightblue' : 'initial',
                                                        borderColor: activeButton === 'folders' ? 'blue' : 'initial',
                                                        visibility: isCollapsed ? 'hidden' : 'visible',
                                                    }}
                                                />
                                            </Tooltip>
                                        </>
                                    }
                                />

                            </div>


                            {!isCollapsed && (
                                <Spin spinning={loading || treeData.length === 0} tip="Cargando árbol de archivos..." size="large">
                                    <div style={{ ...treeContainerStyle, minHeight: '300px' }}>
                                        <DirectoryTree
                                            treeData={treeData}
                                            expandedKeys={expandedKeys}
                                            onExpand={onExpand}
                                            onSelect={handleSelect}
                                            autoExpandParent={autoExpandParent}
                                            titleRender={titleRenderer}
                                            showLine={true}
                                            multiple
                                            defaultExpandAll={true}
                                        />
                                    </div>
                                </Spin>
                            )}
                        </div>
                    </Sider>

                    <Content style={{ padding: 24, overflow: 'auto', background: '#fff' }}>
                        {showWarning && (
                            <Alert
                                message="Advertencia"
                                description="Debe seleccionar un código de tarea para ver los medios de verificación."
                                type="warning"
                                showIcon
                                className="mb-3"
                            />
                        )}
                        {loading ? (
                            <div className="text-center">
                                <Spin size="large" />
                            </div>
                        ) : (
                            <div className="container-fluid" style={{ marginBottom: '20px !important', padding: '0px 0px 0px' }}>

                                {codigo_tarea?.codigo_tarea?.codigo_tarea && (
                                    showDescriptions ? (
                                        <div style={{ position: 'relative' }}>
                                            <Tooltip title="Cerrar">
                                                <Button
                                                    type="primary"
                                                    icon={<CloseOutlined style={{ color: '#FFF', fontSize: 12 }} />}
                                                    onClick={() => setShowDescriptions(false)}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-15px',
                                                        left: '-6px',
                                                        zIndex: 10,
                                                        padding: '5px 10px',
                                                        width: 20,
                                                        height: 22,
                                                        backgroundColor: 'red',
                                                        transform: 'rotate(90deg)',
                                                    }}
                                                />
                                            </Tooltip>

                                            <Descriptions
                                                bordered
                                                column={1}
                                                style={{ padding: '0 0 0 0' }}
                                            >
                                                <Descriptions.Item label="Actividad">
                                                    {codActividad} - {nameActividad}
                                                </Descriptions.Item>
                                                <Descriptions.Item label="Tarea">
                                                    {codigoTarea} - {tarea}
                                                </Descriptions.Item>
                                                <Descriptions.Item label="Indicador">
                                                    {indicador}
                                                </Descriptions.Item>
                                                <Descriptions.Item label="Medio de verificación">
                                                    <div>
                                                        {typeof medioVerificacion === 'string'
                                                            ? medioVerificacion
                                                            : JSON.stringify(medioVerificacion)}
                                                    </div>
                                                </Descriptions.Item>
                                            </Descriptions>
                                        </div>
                                    ) : (
                                        <Button
                                            type="link"
                                            onClick={() => setShowDescriptions(true)}
                                            icon={<CloseOutlined rotate={45} />} // Icono tipo "+"
                                        >
                                            Mostrar detalles
                                        </Button>
                                    )
                                )}

                                <br />
                                <Layout>

                                    <Layout style={{ padding: '0px 0px 0px' }}>
                                        <Content
                                            className="site-layout-background"
                                            style={{
                                                padding: 0,
                                                margin: 0,
                                                minHeight: 280,
                                            }}
                                        >
                                            {selectedItem && !rootNodeSelected && selectedItem.type === 'file' && (
                                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                                    <WarningOutlined style={{ color: 'red', marginRight: '8px', fontSize: '2rem' }} />
                                                    <h4>Seleccione el padre o la carpeta principal</h4>
                                                </div>
                                            )}
                                            {rootNodeSelected && !selectedItem && (
                                                <div style={{ textAlign: 'center', padding: '0px', marginTop: '-5px !important' }}>
                                                    <p className="titulo_proyecto display-4">Bienvenid@</p>
                                                    {treeData.length > 0 ? (
                                                        <div>
                                                            <Table
                                                                dataSource={treeData}
                                                                pagination={tableParams.pagination}
                                                                onChange={handleTableChange}
                                                                expandable={{ defaultExpandAllRows: true }}
                                                                scroll={{
                                                                    y: 340,
                                                                }}
                                                                columns={[
                                                                    {
                                                                        title: 'Resumen',
                                                                        dataIndex: 'name',
                                                                        key: 'key',
                                                                        width: 260,

                                                                        render: (text, record) => {
                                                                            const maxLength = 50;
                                                                            const maxLengthTooltip = 200;
                                                                            let truncatedTitle;

                                                                            if (record.type === 'file') {
                                                                                truncatedTitle = processFileName(record.viewName, maxLength);
                                                                            } else {
                                                                                truncatedTitle = record.viewName;
                                                                            }
                                                                            const truncatedTooltip = processFileName(record.viewName, maxLengthTooltip);

                                                                            return (
                                                                                <Tooltip title={truncatedTooltip} placement="right">
                                                                                    <span>
                                                                                        {record.type === 'folder' ? <FolderOutlined /> : <FileOutlined />}
                                                                                        {` ${truncatedTitle}`}
                                                                                    </span>
                                                                                </Tooltip>
                                                                            );
                                                                        }
                                                                    },
                                                                    {
                                                                        title: 'Tipo',
                                                                        key: 'extension',
                                                                        width: 100,
                                                                        align: 'center',
                                                                        render: (text, record) => {
                                                                            // Verifica si record.name es una cadena de texto
                                                                            if (typeof record.name === 'string') {
                                                                                if (record.type === 'folder' && typeof record.fileCount !== 'undefined') {
                                                                                    const pathContainsTarea = record.path.includes("tarea_221/indicador_34/");
                                                                                    const fileCountToDisplay = pathContainsTarea ? (record.fileCount - record.filePhoto === 0 ? record.fileCount : record.fileCount - record.filePhoto) : record.fileCount;
                                                                                    return (
                                                                                        <>
                                                                                            <Tooltip title="Cantidad de archivos que contiene la carpeta">
                                                                                                <span>Folder</span> <span></span>
                                                                                                <Badge
                                                                                                    className="site-badge-count-109"
                                                                                                    count={fileCountToDisplay}
                                                                                                    overflowCount={9999}
                                                                                                    style={{
                                                                                                        backgroundColor: '#52c41a',
                                                                                                    }}
                                                                                                />
                                                                                            </Tooltip>
                                                                                        </>
                                                                                    );
                                                                                }
                                                                                else if (record.type === 'folder' && record.children.some(child => child.type === 'file')) {
                                                                                    return (
                                                                                        <>
                                                                                            <Tooltip title="Cantidad de archivos que contiene la carpeta">
                                                                                                <span>Folder</span> <span>  </span>
                                                                                                <Badge
                                                                                                    className="site-badge-count-109"
                                                                                                    count={record.children.length}
                                                                                                    style={{
                                                                                                        backgroundColor: '#52c41a',
                                                                                                    }}
                                                                                                />
                                                                                            </Tooltip>
                                                                                        </>
                                                                                    );
                                                                                } else {
                                                                                    if (record.type === 'folder') {
                                                                                        return 'Folder'; // O cualquier otro mensaje adecuado para carpetas vacías
                                                                                    } else {
                                                                                        const fileNameParts = record.name.split('.');
                                                                                        return fileNameParts.length > 1 ? fileNameParts.pop() : 'Archivo';
                                                                                    }
                                                                                }
                                                                            } else {
                                                                                // Maneja el caso en que record.name no es una cadena de texto
                                                                                return 'Desconocido'; // O cualquier otro valor predeterminado adecuado
                                                                            }
                                                                        },

                                                                    },

                                                                ]}

                                                            />
                                                        </div>

                                                    ) : (
                                                        <>
                                                            <h4 className='text-center mb-2'>Seleccione alguna opción del menu para navegar por los archivos</h4>
                                                        </>)
                                                    }

                                                </div>
                                            )}
                                            {selectedItem && !rootNodeSelected && selectedItem.type !== 'file' && (
                                                <Space direction="vertical" style={{ width: '100%' }} size="small">
                                                    <Row gutter={0}>
                                                        <Col span={24}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0px' }}>

                                                                <div style={{ flex: '1 1 auto' }}>
                                                                    {isEditing ? (
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                            <Input
                                                                                value={newName}
                                                                                onChange={handleEditNameChange}
                                                                                onBlur={() => {
                                                                                    if (newName.trim() !== '') {
                                                                                        handleEditFolder(selectedItem.path, newName.trim());
                                                                                        toggleEditMode();
                                                                                    } else {
                                                                                        message.error('El nombre no puede estar vacío.');
                                                                                        cancelEditMode();
                                                                                    }
                                                                                }}
                                                                                onPressEnter={() => {
                                                                                    if (newName.trim() !== '') {
                                                                                        handleEditFolder(selectedItem.path, newName.trim());
                                                                                        toggleEditMode();
                                                                                    } else {
                                                                                        message.error('El nombre no puede estar vacío.');
                                                                                        cancelEditMode();
                                                                                    }
                                                                                }}
                                                                                style={{ width: '85%' }}
                                                                            />
                                                                            <Button
                                                                                type="link"
                                                                                icon={<SaveOutlined />}
                                                                                onClick={() => {
                                                                                    if (newName.trim() !== '') {
                                                                                        handleEditFolder(selectedItem.path, newName.trim());
                                                                                        toggleEditMode();
                                                                                    } else {
                                                                                        message.error('El nombre no puede estar vacío.');
                                                                                        cancelEditMode();
                                                                                    }
                                                                                }}
                                                                                className='btn btn-primary py-0'
                                                                            >
                                                                                Guardar
                                                                            </Button>
                                                                            <Button
                                                                                type="link"
                                                                                icon={<CloseOutlined />}
                                                                                onClick={cancelEditMode}
                                                                                className='btn btn-danger py-0'
                                                                            >
                                                                                Cancelar
                                                                            </Button>
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            {formattedTypeS !== 'Desconocido' ? (
                                                                                <strong>{formattedTypeS}: </strong>
                                                                            ) : (
                                                                                <strong>Folder: </strong>
                                                                            )}
                                                                            <strong>{selectedItem.viewName}</strong>
                                                                        </>
                                                                    )}
                                                                </div>

                                                                {selectedItem.type === 'folder' && permissionInsert && permissionAccess &&
                                                                    selectedItem.children?.every(child => child.type !== 'folder') ? (
                                                                    <Tooltip title="Haga clic para cargar el soporte en esta carpeta">
                                                                        <Button
                                                                            onClick={handleOkFile}
                                                                            onMouseEnter={() => setHover(true)}
                                                                            onMouseLeave={() => setHover(false)}
                                                                            style={{
                                                                                marginRight: '7px',
                                                                                padding: '10px 0px 0px',
                                                                                border: 'none',
                                                                                cursor: 'pointer',
                                                                                transition: 'background 0.3s ease, transform 0.3s ease',
                                                                                boxShadow: 'none',
                                                                                backgroundColor: hover ? '#1677ff' : 'transparent',
                                                                            }}
                                                                        >
                                                                            <CloudUploadOutlined
                                                                                style={{
                                                                                    fontSize: hover ? '32px' : '27px',
                                                                                    marginBottom: '10px',
                                                                                    color: hover ? '#fff' : '#1677ff',
                                                                                    transition: 'color 0.3s ease, font-size 0.3s ease',
                                                                                }}
                                                                            />
                                                                        </Button>
                                                                    </Tooltip>
                                                                ) : null}
                                                                {!isEditing && (
                                                                    <div style={{ display: 'inline-flex', justifyContent: 'flex-end', gap: '6px' }}>
                                                                        {(permissionInsert7 && estadoActEnt) && (
                                                                            <Tooltip title="Sistema de Reemplazos">
                                                                                <Button
                                                                                    type="link"
                                                                                    icon={<FileSyncOutlined style={{ color: '#fff' }} />}
                                                                                    onClick={() => {
                                                                                        setModalOpen(true)
                                                                                        setSelectItemRemplazo(selectedItem.path)
                                                                                    }}
                                                                                    className='btn btn-primary py-0'
                                                                                >

                                                                                </Button>
                                                                            </Tooltip>
                                                                        )}
                                                                        {permissionUpdate && selectedItem.typeS !== 'medio_verificacion' && permissionAccess && (
                                                                            <Tooltip title="Editar nombre de la carpeta">
                                                                                <Button
                                                                                    type="link"
                                                                                    icon={<EditOutlined style={{ color: '#fff' }} />}
                                                                                    onClick={toggleEditMode}
                                                                                    className='btn btn-primary py-0'
                                                                                >

                                                                                </Button>
                                                                            </Tooltip>
                                                                        )}

                                                                        {informe332Visible && (
                                                                            <Tooltip title="Informe de capacitación">
                                                                                <Button
                                                                                    type="link"
                                                                                    danger
                                                                                    icon={<BarChartOutlined />}
                                                                                    className="btn btn-primary py-0"
                                                                                    style={{ color: "#FFF" }}
                                                                                    onClick={abrirInforme332}   // 👈 ABRIR MODAL
                                                                                />
                                                                            </Tooltip>
                                                                        )}


                                                                        {permissionPrint && permissionAccess && (
                                                                            <Tooltip title="Crear un directorio en la ubicación actual.">
                                                                                <Popconfirm
                                                                                    title='Crear directorio'
                                                                                    description="¿Segur@ que quieres crear un directorio?"
                                                                                    onConfirm={showCreateFolderModal}
                                                                                    okText="Sí"
                                                                                    cancelText="No"
                                                                                    icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                                                                >
                                                                                    <Button
                                                                                        type="link"
                                                                                        danger
                                                                                        icon={<FolderAddFilled />}
                                                                                        className='btn btn-primary py-0'
                                                                                        style={{ color: '#FFF' }}
                                                                                    />
                                                                                </Popconfirm>
                                                                            </Tooltip>
                                                                        )}
                                                                        {permissionDelete3 && selectedItem.typeS !== 'medio_verificacion' && permissionAccess && (

                                                                            <Tooltip title="Eliminar del directorio actual">
                                                                                <Popconfirm
                                                                                    title='Eliminación de directorio'
                                                                                    description="¿Segur@ que quieres eliminar este directorio, no podrás revertir esta operación?"
                                                                                    onConfirm={() => handleDeleteFolder(selectedItem.path, selectedItem)}
                                                                                    okText="Sí"
                                                                                    cancelText="No"
                                                                                    icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                                                                >
                                                                                    <Button
                                                                                        type="link"
                                                                                        danger
                                                                                        icon={<DeleteOutlined />}
                                                                                        className='btn btn-primary py-0'
                                                                                        style={{ color: '#FFF', background: '#ee1a0b', borderColor: '#ee1a0b' }}
                                                                                    />
                                                                                </Popconfirm>
                                                                            </Tooltip>
                                                                        )}
                                                                        {permissionExport && permissionAccess && (
                                                                            <Tooltip title="Descarga soportes">
                                                                                <Popconfirm
                                                                                    title="Descargar soporte"
                                                                                    description="¿Segur@ que quieres descargar el soporte?"
                                                                                    onConfirm={() => handleDescargar(selectedItem)}
                                                                                    okText="Sí"
                                                                                    cancelText="No"
                                                                                >
                                                                                    <Button
                                                                                        type="link"
                                                                                        loading={downloading}   // 👈 usa el nuevo estado
                                                                                        icon={!downloading && <DownloadOutlined style={{ color: '#fff' }} />}
                                                                                        className="btn btn-primary py-0"
                                                                                    />
                                                                                </Popconfirm>
                                                                            </Tooltip>


                                                                        )}
                                                                        {permissionInsert3 && fileInsetAll && selectedItem.type === 'folder' && permissionAccess3 &&
                                                                            selectedItem.children?.every(child => child.type !== 'folder') ?
                                                                            (
                                                                                <Tooltip title="Subir varios archivos">
                                                                                    <Button
                                                                                        type="link"
                                                                                        danger
                                                                                        icon={<FileAddOutlined />}
                                                                                        className="btn btn-primary py-0"
                                                                                        style={{ color: '#FFF' }}
                                                                                        onClick={showModalAllFile}
                                                                                    />
                                                                                </Tooltip>
                                                                            ) : null
                                                                        }
                                                                        {permissionPrint3 && fileInsetAll && selectedItem.type === 'folder' && permissionAccess3 &&
                                                                            selectedItem.children?.every(child => child.type !== 'folder') ?
                                                                            (
                                                                                <FileManagerModal rutaRelativa={selectedItem} limpiar={onLimpiarBusqueda} rutaActividad={codigo_tarea} />
                                                                            ) : null
                                                                        }
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={1}>
                                                        <Col span={24}>
                                                            <Space direction="vertical" size="large" style={{ width: '100%', paddingTop: '0px !important', marginTop: '0px !important' }}>
                                                                {renderSelectedFiles()}
                                                            </Space>
                                                        </Col>
                                                    </Row>
                                                </Space>
                                            )}
                                        </Content>
                                    </Layout>
                                </Layout>
                                <Modal
                                    title="Crear nueva carpeta"
                                    open={isModalVisible}
                                    onOk={handleCreateFolder}
                                    onCancel={() => {
                                        setIsModalVisible(false);
                                        setNewFolderName('');
                                    }}
                                    okText="Crear"
                                    cancelText="Cancelar"
                                >
                                    <Input
                                        ref={inputRef}
                                        placeholder="Nombre de la nueva carpeta"
                                        value={newFolderName}
                                        onChange={handleNameChange}
                                        onKeyDown={handleKeyDown}
                                    />
                                </Modal>
                                <Modal
                                    title={<span style={{ fontWeight: 'bold', fontSize: '20px', textAlign: 'center', display: 'block' }}>Cargar soportes</span>}
                                    open={isModalFileVisible}
                                    onOk={handleFormSubmit}
                                    onCancel={handleCancelFile}
                                    width="45vw"
                                    style={{
                                        maxHeight: '60vh',
                                        top: 20,
                                    }}
                                    footer={null}
                                    styles={{ paddingTop: '20px' }}
                                >
                                    <div>
                                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
                                            {permissionInsert && selectedItem?.pathFromClient && permissionAccess && (
                                                <div>
                                                    {mostrarPrimerTexto ? (
                                                        <p style={{ textAlign: 'center', marginBottom: '20px', color: '#5c5a5a' }}>
                                                            Cargar el Reporte de visita de acompañamiento en formato PDF y renombrarlo de la siguiente manera: Fecha de la visita_Reporte Visita_Cédula del participante.
                                                        </p>
                                                    ) : mostrarSegundoTexto ? (
                                                        <p style={{ textAlign: 'center', marginBottom: '20px', color: '#5c5a5a' }}>
                                                            Cargar las actas de entrega con todos sus apartados diligenciados, incluyendo el de firmas y en formato PDF.
                                                        </p>
                                                    ) : (
                                                        <p style={{ textAlign: 'center', marginBottom: '20px', color: '#5c5a5a' }}></p>
                                                    )}
                                                    {
                                                        (
                                                            <>
                                                                {controlMensaje ? (
                                                                    <>
                                                                        <Form
                                                                            labelCol={{ span: 10 }}
                                                                            wrapperCol={{ span: 50 }}
                                                                            layout="vertical"
                                                                            form={form}
                                                                            initialValues={{
                                                                                fecha: null,
                                                                                titulo: '',
                                                                                resourceType: null,
                                                                            }}
                                                                            onFinish={handleFormSubmit}
                                                                        >
                                                                            <Form.Item
                                                                                label="Nombre del soporte"
                                                                                name="titulo"
                                                                                rules={[
                                                                                    { required: true, message: 'Por favor, ingrese el Nombre del soporte' },
                                                                                    {
                                                                                        pattern: /^[0-9]{8}_Reporte Visita_C[0-9]+$/,
                                                                                        message: (
                                                                                            <div>
                                                                                                <p>El formato debe ser ddmmyyyy_Reporte Visita_Cédula del participante. Ej: 10112024_Reporte Visita_C1056845345</p>
                                                                                                <ul>
                                                                                                    <li>Fecha en la que se realizó la visita de acompañamiento, en formato día-mes-año</li>
                                                                                                    <li>Guion bajo</li>
                                                                                                    <li>Nombre descriptivo del archivo: Reporte Visita</li>
                                                                                                    <li>Guion bajo</li>
                                                                                                    <li>Número de cédula del participante, precedido por la letra en mayúscula "C"</li>
                                                                                                </ul>
                                                                                            </div>
                                                                                        ),
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <Input />
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                label="Tipo de soporte:"
                                                                                name="resourceType"
                                                                                rules={[{ required: true, message: 'Por favor, seleccione un tipo de soporte' }]}
                                                                            >
                                                                                <Radio.Group>
                                                                                    <Radio value="Informe">Informe</Radio>
                                                                                </Radio.Group>
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                label="Carga de Soporte"
                                                                                name="soporte"
                                                                                rules={[{ required: true, message: 'Por favor, seleccione un soporte' }]}
                                                                            >
                                                                                <div className="centered-dragger">
                                                                                    <Tooltip title="Subir Soporte">
                                                                                        <Dragger
                                                                                            multiple={false}
                                                                                            maxCount={1}
                                                                                            beforeUpload={() => false}
                                                                                            onChange={(info) => {
                                                                                                const currentFileList = info.fileList;
                                                                                                if (currentFileList.length > 0) {
                                                                                                    const fileWrapper = currentFileList[currentFileList.length - 1];
                                                                                                    const file = fileWrapper.originFileObj;
                                                                                                    if (file) {
                                                                                                        const maxSize = 100 * 1024 * 1024;
                                                                                                        if (file.size === 0 || file.type?.includes("directory")) {
                                                                                                            message.warning(`"${file.name}" es una carpeta y no está permitida.`);
                                                                                                            setFileList([]);
                                                                                                            setFileToUpload(null);
                                                                                                            return;
                                                                                                        }
                                                                                                        if (file.size > maxSize) {
                                                                                                            message.warning(`"${file.name}" excede el tamaño máximo de 100MB.`);
                                                                                                            setFileList([]);
                                                                                                            setFileToUpload(null);
                                                                                                            return;
                                                                                                        }
                                                                                                        setFileList([fileWrapper]);
                                                                                                        setFileToUpload(file);
                                                                                                        form.setFieldValue("soporte", file.name);
                                                                                                    }
                                                                                                } else {
                                                                                                    setFileList([]);
                                                                                                    setFileToUpload(null);
                                                                                                }
                                                                                            }}
                                                                                            onRemove={() => {
                                                                                                setFileList([]);
                                                                                                setFileToUpload(null);
                                                                                            }}
                                                                                            style={{ width: '300px' }}
                                                                                        >
                                                                                            <p className="ant-upload-drag-icon">
                                                                                                <InboxOutlined />
                                                                                            </p>
                                                                                            <p className="ant-upload-text">Haga clic o arrastre el archivo aquí</p>
                                                                                            <p className="ant-upload-hint">Solo se permite un archivo a la vez.</p>
                                                                                        </Dragger>
                                                                                    </Tooltip>
                                                                                </div>
                                                                            </Form.Item>
                                                                            <Form.Item>
                                                                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                                                                                    <Button
                                                                                        type="primary"
                                                                                        onClick={handleFormSubmit}
                                                                                        style={{ marginRight: 8 }}
                                                                                        disabled={isSubmitting}
                                                                                    >
                                                                                        {isSubmitting ? 'Guardando...' : 'Guardar'}
                                                                                    </Button>
                                                                                    <Button
                                                                                        type="primary"
                                                                                        onClick={handleCancelFile}
                                                                                        danger
                                                                                    >
                                                                                        Cancelar
                                                                                    </Button>
                                                                                </div>
                                                                            </Form.Item>
                                                                        </Form>
                                                                    </>
                                                                ) : controlMensaje34 ? (
                                                                    <>
                                                                        <Form
                                                                            labelCol={{ span: 10 }}
                                                                            wrapperCol={{ span: 50 }}
                                                                            layout="vertical"
                                                                            form={form}
                                                                            initialValues={{
                                                                                fecha: null,
                                                                                titulo: '',
                                                                                resourceType: null,
                                                                            }}
                                                                            onFinish={handleFormSubmit}
                                                                        >
                                                                            <Form.Item
                                                                                label="Nombre del soporte"
                                                                                name="titulo"
                                                                                rules={[
                                                                                    { required: true, message: 'Por favor, ingrese el Nombre del soporte' },
                                                                                    {
                                                                                        pattern: /^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])(19|20)[0-9]{2}_(Infraestructura|Materiales|Insumos|Insumos_infraestructura|Informe)_([CN][0-9]+|([A-Z][a-záéíóúñ]+(?: [A-Z][a-záéíóúñ]+)*))$/,
                                                                                        message: (
                                                                                            <div>
                                                                                                <Typography>
                                                                                                    <Title level={4} style={{ color: 'red' }}>Nomenclatura para Actas de Entrega</Title>
                                                                                                    <Paragraph>
                                                                                                        Las actas de entrega deben mencionar en el nombre del archivo al menos la categoría a la que pertenecen la mayoría de ítems entregados.
                                                                                                    </Paragraph>
                                                                                                    <Paragraph>
                                                                                                        <Text strong>1️⃣ Infraestructura:</Text> Corresponde a casos como secaderos, cobertizos, enramadas, gallineros, cajones, marquesinas, trapiches, entre otros. Se deben nombrar así:
                                                                                                    </Paragraph>
                                                                                                    <Paragraph code>
                                                                                                        24052025_Infraestructura_C16821035 o 24052025_Infraestructura_N16821035
                                                                                                    </Paragraph>
                                                                                                    <Paragraph>
                                                                                                        <Text strong>2️⃣ Materiales:</Text> Aplica cuando se entregan materiales para construcción.
                                                                                                    </Paragraph>
                                                                                                    <Paragraph code>
                                                                                                        24052025_Materiales_C16821035 o 24052025_Materiales_N16821035
                                                                                                    </Paragraph>
                                                                                                    <Paragraph>
                                                                                                        <Text strong>3️⃣ Insumos:</Text> Para los demás ítems del plan de inversión.
                                                                                                    </Paragraph>
                                                                                                    <Paragraph code>
                                                                                                        24052025_Insumos_C16821035 o 24052025_Insumos_N16821035
                                                                                                    </Paragraph>
                                                                                                    <Paragraph>
                                                                                                        <Text strong>4️⃣ Entregas con múltiples categorías:</Text>
                                                                                                    </Paragraph>
                                                                                                    <Paragraph code>
                                                                                                        24052025_Insumos_infraestructura_C16821035 o 24052025_Insumos_infraestructura_N16821035
                                                                                                    </Paragraph>
                                                                                                </Typography>
                                                                                            </div>
                                                                                        ),
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <Input />
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                label="Tipo de soporte:"
                                                                                name="resourceType"
                                                                                rules={[{ required: true, message: 'Por favor, seleccione un tipo de soporte' }]}
                                                                            >
                                                                                <Radio.Group>
                                                                                    <Radio value="Acta_entrega">Acta de entrega</Radio>
                                                                                </Radio.Group>
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                label="Categoría:"
                                                                                name="categoriaUser"
                                                                                rules={[{ required: true, message: 'Por favor, seleccione un tipo de entrega' }]}
                                                                            >
                                                                                <Radio.Group>
                                                                                    <Radio value="Sin categorizar">Sin categorizar</Radio>
                                                                                    <Radio value="Infraestructura">Infraestructura</Radio>
                                                                                    <Radio value="Materiales">Materiales</Radio>
                                                                                    <Radio value="Insumos">Insumos</Radio>
                                                                                    <Radio value="Insumos e infraestructura">Insumos e infraestructura</Radio>
                                                                                </Radio.Group>
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                label="Carga de Soporte"
                                                                                name="soporte"
                                                                                rules={[{ required: true, message: 'Por favor, seleccione un soporte' }]}
                                                                            >
                                                                                <div className="centered-dragger">
                                                                                    <Tooltip title="Subir Soporte">
                                                                                        <Dragger
                                                                                            multiple={false}
                                                                                            maxCount={1}
                                                                                            beforeUpload={() => false}
                                                                                            onChange={(info) => {
                                                                                                const currentFileList = info.fileList;
                                                                                                if (currentFileList.length > 0) {
                                                                                                    const fileWrapper = currentFileList[currentFileList.length - 1];
                                                                                                    const file = fileWrapper.originFileObj;
                                                                                                    if (file) {
                                                                                                        const maxSize = 100 * 1024 * 1024;
                                                                                                        if (file.size === 0 || file.type?.includes('directory')) {
                                                                                                            message.warning(`"${file.name}" es una carpeta y no está permitida.`);
                                                                                                            setFileList([]);
                                                                                                            setFileToUpload(null);
                                                                                                            return;
                                                                                                        }
                                                                                                        if (file.size > maxSize) {
                                                                                                            message.warning(`"${file.name}" excede el tamaño máximo de 100MB.`);
                                                                                                            setFileList([]);
                                                                                                            setFileToUpload(null);
                                                                                                            return;
                                                                                                        }
                                                                                                        setFileList([fileWrapper]);
                                                                                                        setFileToUpload(file);
                                                                                                        form.setFieldValue("soporte", file.name);
                                                                                                    }
                                                                                                } else {
                                                                                                    setFileList([]);
                                                                                                    setFileToUpload(null);
                                                                                                }
                                                                                            }}
                                                                                            onRemove={() => {
                                                                                                setFileList([]);
                                                                                                setFileToUpload(null);
                                                                                            }}
                                                                                            style={{ width: '300px' }}
                                                                                        >
                                                                                            <p className="ant-upload-drag-icon">
                                                                                                <InboxOutlined />
                                                                                            </p>
                                                                                            <p className="ant-upload-text">Haga clic o arrastre el archivo aquí</p>
                                                                                            <p className="ant-upload-hint">Solo se permite un archivo a la vez.</p>
                                                                                        </Dragger>
                                                                                    </Tooltip>
                                                                                </div>
                                                                            </Form.Item>
                                                                            <Form.Item>
                                                                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                                                                                    <Button
                                                                                        type="primary"
                                                                                        onClick={handleFormSubmit}
                                                                                        style={{ marginRight: 8 }}
                                                                                        disabled={isSubmitting}
                                                                                    >
                                                                                        {isSubmitting ? 'Guardando...' : 'Guardar'}
                                                                                    </Button>
                                                                                    <Button
                                                                                        type="primary"
                                                                                        onClick={handleCancelFile}
                                                                                        danger
                                                                                    >
                                                                                        Cancelar
                                                                                    </Button>
                                                                                </div>
                                                                            </Form.Item>
                                                                        </Form>
                                                                    </>
                                                                ) : nuevaRuta ? (
                                                                    <>
                                                                        <Form
                                                                            layout="vertical"
                                                                            form={form}
                                                                            initialValues={{
                                                                                titulo: "",
                                                                            }}
                                                                            onFinish={async (values) => {
                                                                                if (!fileList || fileList.length === 0) {
                                                                                    message.warning("Por favor, selecciona al menos un archivo.");
                                                                                    return;
                                                                                }
                                                                                const titulo =
                                                                                    values.titulo && values.titulo.trim() !== ""
                                                                                        ? values.titulo
                                                                                        : `Archivo_${rutaInformacionGeneral}`;
                                                                                const resourceType = `Soporte ${rutaInformacionGeneral}`;
                                                                                const categoriaUser = "Sin categorizar";
                                                                                const renamedFiles = await Promise.all(
                                                                                    fileList.map(async (file) => {
                                                                                        const ext = file.name.split(".").pop();
                                                                                        const buffer = await file.arrayBuffer(); // 👈 archivo real, no originFileObj
                                                                                        const cleanTitle = titulo.replace(/[^\w\s-]/g, "").replace(/\s+/g, "_");
                                                                                        return new File([buffer], `${cleanTitle}.${ext}`, { type: file.type });
                                                                                    })
                                                                                );
                                                                                for (const renamedFile of renamedFiles) {
                                                                                    await handleCustomRequest({
                                                                                        file: renamedFile,
                                                                                        onSuccess: () => {
                                                                                            message.success(`${renamedFile.name} guardado correctamente.`);
                                                                                        },
                                                                                        onError: (error) => {
                                                                                            console.error("Error al subir:", error);
                                                                                            message.error(`Error al subir ${renamedFile.name}`);
                                                                                        },
                                                                                        resourceType,
                                                                                        categoriaUser,
                                                                                    });
                                                                                }
                                                                                form.resetFields();
                                                                                setFileList([]);
                                                                            }}
                                                                        >
                                                                            <Form.Item
                                                                                label="Título del archivo"
                                                                                name="titulo"
                                                                                rules={[{ required: true, message: "Ingrese un título para el archivo" }]}
                                                                            >
                                                                                <Input
                                                                                    placeholder="Ej: Archivo de soporte"
                                                                                    allowClear
                                                                                    style={{
                                                                                        borderRadius: "8px",
                                                                                        borderColor: "#d9d9d9",
                                                                                    }}
                                                                                />
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                label={
                                                                                    <span style={{ fontWeight: "500", color: "#333" }}>
                                                                                        Archivo(s) a subir
                                                                                    </span>
                                                                                }
                                                                            >
                                                                                <Upload.Dragger
                                                                                    multiple={false}
                                                                                    beforeUpload={(file) => {
                                                                                        setFileList([file]);
                                                                                        return false;
                                                                                    }}
                                                                                    onRemove={() => setFileList([])}
                                                                                    fileList={fileList}
                                                                                    accept=".pdf,.docx,.xlsx,.jpg,.png,.zip"
                                                                                    style={{
                                                                                        borderRadius: "12px",
                                                                                        borderColor: "#91caff",
                                                                                        backgroundColor: "#f5faff",
                                                                                        padding: "24px",
                                                                                    }}
                                                                                >
                                                                                    <p className="ant-upload-drag-icon" style={{ color: "#1677ff" }}>
                                                                                        <InboxOutlined style={{ fontSize: "40px" }} />
                                                                                    </p>
                                                                                    <p className="ant-upload-text">
                                                                                        Arrastra o haz clic para seleccionar el archivo
                                                                                    </p>
                                                                                    <p className="ant-upload-hint" style={{ color: "#888" }}>
                                                                                        Solo se permite un archivo (PDF, DOCX, XLSX, JPG, PNG o ZIP)
                                                                                    </p>
                                                                                </Upload.Dragger>
                                                                            </Form.Item>
                                                                            <Form.Item style={{ textAlign: "center", marginTop: "20px" }}>
                                                                                <Button
                                                                                    type="primary"
                                                                                    htmlType="submit"
                                                                                    size="large"
                                                                                    style={{
                                                                                        borderRadius: "8px",
                                                                                        padding: "0 40px",
                                                                                        fontWeight: "500",
                                                                                        backgroundColor: "#1677ff",
                                                                                        boxShadow: "0 3px 6px rgba(22, 119, 255, 0.3)",
                                                                                    }}
                                                                                >
                                                                                    Guardar archivo(s)
                                                                                </Button>
                                                                            </Form.Item>
                                                                        </Form>
                                                                    </>) : (
                                                                    <>
                                                                        <Form
                                                                            labelCol={{ span: 10 }}
                                                                            wrapperCol={{ span: 50 }}
                                                                            layout="vertical"
                                                                            form={form}
                                                                            initialValues={{
                                                                                fecha: null,
                                                                                titulo: '',
                                                                                resourceType: null,
                                                                            }}
                                                                            onFinish={handleFormSubmit}
                                                                        >
                                                                            <Form.Item
                                                                                label="Nombre del soporte"
                                                                                name="titulo"
                                                                                rules={instrumento ? [] : [
                                                                                    { required: true, message: 'Por favor, ingrese el Nombre del soporte' },
                                                                                    {
                                                                                        pattern: /^[0-9]{8}_[A-ZÁÉÍÓÚÑ][a-zA-Z0-9 _\-áéíóúÁÉÍÓÚñÑ.,]*_[A-ZÁÉÍÓÚÑ][a-zA-Z0-9 _\-áéíóúÁÉÍÓÚñÑ.,]*$/,
                                                                                        message: (
                                                                                            <div>
                                                                                                <p>El formato debe ser ddmmyyyy_Tipo_Ubicación. Ej: 18112023_Memoria_ElCharco</p>
                                                                                                <ul>
                                                                                                    <li>Fecha en la que se realizó el espacio o el documento, en formato día-mes-año</li>
                                                                                                    <li>Guion bajo</li>
                                                                                                    <li>Nombre descriptivo corto del archivo</li>
                                                                                                    <li>Guion bajo</li>
                                                                                                    <li>Especificar el municipio o vereda en la que se realizó el espacio</li>
                                                                                                </ul>
                                                                                            </div>
                                                                                        ),
                                                                                    }
                                                                                ]}
                                                                            >
                                                                                <Input value={selectedItem.name} />
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                label="Tipo de soporte"
                                                                                name="resourceType"
                                                                                rules={[{ required: true, message: 'Por favor, seleccione un tipo de soporte' }]}
                                                                            >
                                                                                <Radio.Group>
                                                                                    <Radio value="Memoria">Memoria</Radio>
                                                                                    <Radio value="Acta">Acta</Radio>
                                                                                    <Radio value="PPT">PPT</Radio>
                                                                                    <Radio value="Asistencia">Asistencia</Radio>
                                                                                    <Radio value="Informe">Informe</Radio>
                                                                                    <Radio value="Foto">Foto</Radio>
                                                                                    <Radio value="Grabación">Grabación</Radio>
                                                                                    <Radio value="Correo Aprobación">Correo Aprobación</Radio>
                                                                                    <Radio value="Documento técnico">Documento técnico</Radio>
                                                                                    <Radio value="Otro">Otro</Radio>
                                                                                </Radio.Group>
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                label="Carga de Soporte"
                                                                                name="soporte"
                                                                                rules={[{ required: true, message: 'Por favor, seleccione un soporte' }]}
                                                                            >
                                                                                <div className="centered-dragger">
                                                                                    <Tooltip title="Subir Soporte">
                                                                                        <Dragger
                                                                                            multiple={false}
                                                                                            maxCount={1}
                                                                                            beforeUpload={() => false}
                                                                                            onChange={(info) => {
                                                                                                const currentFileList = info.fileList;

                                                                                                if (currentFileList.length > 0) {
                                                                                                    const fileWrapper = currentFileList[currentFileList.length - 1];
                                                                                                    const file = fileWrapper.originFileObj;

                                                                                                    if (file) {
                                                                                                        const maxSize = 100 * 1024 * 1024;
                                                                                                        if (file.size === 0 || file.type?.includes('directory')) {
                                                                                                            message.warning(`"${file.name}" es una carpeta y no está permitida.`);
                                                                                                            setFileList([]);
                                                                                                            setFileToUpload(null);
                                                                                                            return;
                                                                                                        }
                                                                                                        if (file.size > maxSize) {
                                                                                                            message.warning(`"${file.name}" excede el tamaño máximo de 100MB.`);
                                                                                                            setFileList([]);
                                                                                                            setFileToUpload(null);
                                                                                                            return;
                                                                                                        }
                                                                                                        form.setFieldValue("soporte", file.name);
                                                                                                        setFileList([fileWrapper]);
                                                                                                        setFileToUpload(file);
                                                                                                    }
                                                                                                } else {
                                                                                                    setFileList([]);
                                                                                                    setFileToUpload(null);
                                                                                                }
                                                                                            }}
                                                                                            onRemove={() => {
                                                                                                setFileList([]);
                                                                                                setFileToUpload(null);
                                                                                            }}
                                                                                            style={{ width: '300px' }}
                                                                                        >
                                                                                            <p className="ant-upload-drag-icon">
                                                                                                <InboxOutlined />
                                                                                            </p>
                                                                                            <p className="ant-upload-text">Haga clic o arrastre el archivo aquí</p>
                                                                                            <p className="ant-upload-hint">Solo se permite un archivo a la vez.</p>
                                                                                        </Dragger>
                                                                                    </Tooltip>
                                                                                </div>
                                                                            </Form.Item>
                                                                            <Form.Item>
                                                                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                                                                                    <Button
                                                                                        type="primary"
                                                                                        onClick={handleFormSubmit}
                                                                                        style={{ marginRight: 8 }}
                                                                                        disabled={isSubmitting}
                                                                                    >
                                                                                        {isSubmitting ? 'Guardando...' : 'Guardar'}
                                                                                    </Button>
                                                                                    <Button
                                                                                        type="primary"
                                                                                        onClick={handleCancelFile}
                                                                                        danger
                                                                                    >
                                                                                        Cancelar
                                                                                    </Button>
                                                                                </div>
                                                                            </Form.Item>
                                                                        </Form>
                                                                    </>
                                                                )}
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            )}
                                        </div>
                                        {loading && (
                                            <div style={{
                                                position: 'fixed',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                zIndex: 1000
                                            }}>
                                                <div style={{ textAlign: 'center' }}>
                                                    <Spin size="large" />
                                                    <Progress percent={uploadProgress} style={{ marginTop: 16 }} />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </Modal>
                                <Modal
                                    title={
                                        <span style={{ fontWeight: "bold", fontSize: "20px", textAlign: "center", display: "block" }}>
                                            {esInformeEDAH ? `Cargar múltiples archivos ${rutaInformacionGeneral}` : "Cargar múltiples soportes"}
                                        </span>
                                    }
                                    open={isModalVisibleAllFile}
                                    onOk={handleFormSubmitAllFile}
                                    onCancel={handleCancelAllFile}
                                    width="45vw"
                                    footer={[
                                        <Button key="back" onClick={handleCancelAllFile} danger>
                                            Cancelar
                                        </Button>,
                                        <Button
                                            key="submit"
                                            type="primary"
                                            loading={isSubmittingAllFile}
                                            onClick={handleFormSubmitAllFile}
                                        >
                                            {isSubmittingAllFile ? "Subiendo..." : "Subir archivos"}
                                        </Button>,
                                    ]}
                                >
                                    <Form
                                        form={formAllFile}
                                        layout="vertical"
                                        initialValues={{
                                            titulo: "",
                                            resourceType: null,
                                        }}
                                    >
                                        {!esInformeEDAH && (
                                            <Form.Item
                                                label="Tipo de soporte:"
                                                name="resourceType"
                                                rules={[{ required: true, message: "Por favor, seleccione un tipo de soporte" }]}
                                            >
                                                <Radio.Group>
                                                    <Radio value="Informe">Informe</Radio>
                                                    <Radio value="Acta_entrega">Acta de entrega</Radio>
                                                    <Radio value="Memoria">Memoria</Radio>
                                                    <Radio value="Acta">Acta</Radio>
                                                    <Radio value="PPT">PPT</Radio>
                                                    <Radio value="Asistencia">Asistencia</Radio>
                                                    <Radio value="Foto">Foto</Radio>
                                                    <Radio value="Grabación">Grabación</Radio>
                                                    <Radio value="Correo Aprobación">Correo Aprobación</Radio>
                                                    <Radio value="Documento técnico">Documento técnico</Radio>
                                                    <Radio value="Otro">Otro</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        )}
                                        <Form.Item
                                            label="Carga de Soportes"
                                            name="soportes"
                                            rules={[{ required: true, message: "Por favor, seleccione al menos un soporte" }]}
                                        >
                                            <div className="centered-dragger">
                                                <Dragger
                                                    multiple
                                                    fileList={fileListAllFile}
                                                    beforeUpload={() => false}
                                                    onChange={(info) => {
                                                        const currentFileList = info.fileList;
                                                        const uniqueFilesMap = new Map();
                                                        const filteredFileList = currentFileList
                                                            .filter((fileWrapper) => {
                                                                const file = fileWrapper.originFileObj;
                                                                if (!file) return false;
                                                                const signature = file.name + file.size + file.type;
                                                                if (uniqueFilesMap.has(signature)) return false;
                                                                uniqueFilesMap.set(signature, true);
                                                                const maxSize = 100 * 1024 * 1024;
                                                                if (file.size === 0 || file.type?.includes("directory")) {
                                                                    message.warning(`"${file.name}" es una carpeta y no está permitida.`);
                                                                    return false;
                                                                }
                                                                if (file.size > maxSize) {
                                                                    message.warning(`"${file.name}" excede el tamaño máximo de 100MB.`);
                                                                    return false;
                                                                }
                                                                return true;
                                                            })
                                                            .map((fileWrapper) => ({
                                                                ...fileWrapper,
                                                                status: "done",
                                                            }));

                                                        setFileListAllFile(filteredFileList);
                                                    }}
                                                    onRemove={(file) => {
                                                        const newList = fileListAllFile.filter((f) => f.uid !== file.uid);
                                                        setFileListAllFile(newList);
                                                    }}
                                                >
                                                    <p className="ant-upload-drag-icon">
                                                        <InboxOutlined />
                                                    </p>
                                                    <p className="ant-upload-text">Haga clic o arrastre archivos aquí</p>
                                                    <p className="ant-upload-hint">Soporte para múltiples archivos. No se permiten carpetas.</p>
                                                </Dragger>
                                            </div>
                                        </Form.Item>
                                        {fileListAllFile.length > 0 && (
                                            <>
                                                <div style={{ marginTop: 16 }}>
                                                    <strong>Archivos seleccionados ({fileListAllFile.length}):</strong>
                                                    <Button
                                                        type="link"
                                                        danger
                                                        size="small"
                                                        onClick={() => setFileListAllFile([])}
                                                        style={{ marginLeft: 10 }}
                                                    >
                                                        Limpiar todo
                                                    </Button>
                                                </div>
                                            </>
                                        )}
                                    </Form>
                                </Modal>
                                {permissionAccess7 && (
                                    <ModalSoporteReemplazo open={modalOpen} onOpenChange={setModalOpen} limpiar={onLimpiarBusqueda} remplazo_ruta={remplazo_ruta} selectItemRemplazo={selectItemRemplazo} />
                                )}
                                {informe332Visible && (<Modal
                                    open={openInforme332}
                                    onCancel={cerrarInforme332}   // ← usar la función
                                    footer={null}
                                    width="90%"
                                    destroyOnHidden={true}
                                >
                                    <Informe332 />
                                </Modal>
                                )}
                            </div >
                        )}
                    </Content>
                </Layout>
            </Drawer>
        </>
    );
};

export default FileManagerPOA;
